/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  AddressLabels,
  Backfill,
  CampaignAnalytics,
  CohortAnalytics,
  CouponRoiAnalytics,
  CustomerAddressLabelRequest,
  CustomerAddressRequest,
  CustomerAnonymizeJob,
  CustomerAnonymizeRequest,
  CustomerAnonymized,
  CustomerBrief,
  CustomerBulkAnonymizeRequest,
  CustomerBulkDeleteResult,
  CustomerBulkIdsRequest,
  CustomerBulkImportRequest,
  CustomerBulkImportResult,
  CustomerBulkPointsRequest,
  CustomerBulkPointsResult,
  CustomerBulkPushRequest,
  CustomerBulkPushResult,
  CustomerBulkSendResult,
  CustomerBulkSmsRequest,
  CustomerCoupon,
  CustomerCreateRequest,
  CustomerDeleted,
  CustomerDeletionRequested,
  CustomerDeletionWithdrawn,
  CustomerDetail,
  CustomerForgotPassword,
  CustomerForgotPasswordRequest,
  CustomerLoggedOut,
  CustomerLoginRequest,
  CustomerLookup,
  CustomerMe,
  CustomerOrders,
  CustomerPage,
  CustomerPasswordChangeRequest,
  CustomerPasswordChanged,
  CustomerPasswordReset,
  CustomerProfileUpdated,
  CustomerPushSubscription,
  CustomerReferrals,
  CustomerRegisterFromCheckoutRequest,
  CustomerRegisterRequest,
  CustomerResetPasswordRequest,
  CustomerSaveAddressRequest,
  CustomerSendEmailRequest,
  CustomerSession,
  DayHourRevenue,
  GameCorrelationAnalytics,
  GetAnalyticsCampaignsParams,
  GetAnalyticsCohortsParams,
  GetAnalyticsCouponsRoiParams,
  GetAnalyticsDayHourRevenueParams,
  GetAnalyticsGameCorrelationParams,
  GetAnalyticsLoyaltyStatsParams,
  GetAnalyticsMarginsParams,
  GetAnalyticsPizzaIngredientsMarginParams,
  GetAnalyticsRevenueParams,
  GetAnalyticsRfmCustomersParams,
  GetAnalyticsSlaParams,
  GetCustomerAuthMeDataExport200,
  GetCustomerAuthMeMostOrderedParams,
  GetCustomerAuthMeReferralsParams,
  GetCustomerAuthMyOrdersOrderId200,
  GetCustomerAuthMyOrdersParams,
  GetCustomersLookupParams,
  GetCustomersLoyaltyCheckParams,
  GetCustomersParams,
  GetReferralsParams,
  GetSmsContactsParams,
  HiddenAddressArray,
  LoyaltyAnalytics,
  LoyaltyCampaign,
  LoyaltyCheckResponse,
  LoyaltyLevelReorderRequest,
  LoyaltyLevelRow,
  LoyaltyNotifyPointsRequest,
  LoyaltyNotifyPointsResult,
  LoyaltyPublicInfo,
  LoyaltySettings,
  LoyaltySettingsWithLevels,
  LoyaltyTestEmailRequest,
  LoyaltyTestEmailResult,
  MarginAnalytics,
  MostOrderedProducts,
  OrderTracking,
  PatchCustomerAuthMeBody,
  PatchCustomersCustomerIdBody,
  PatchLoyaltyLevelsLevelIdBody,
  PersonalisedSuggestion,
  PizzaIngredientsMarginAnalytics,
  PostLoyaltyLevelsBody,
  PushPublicKey,
  PushSubscribeRequest,
  PushSubscriptions,
  PushUnsubscribeRequest,
  PutLoyaltySettingsBody,
  PutSettingsLoyaltyBody,
  RedeemPointsRequest,
  RedeemPointsResponse,
  ReferralInvite,
  ReferralPage,
  ReferralValidation,
  RegisteredCustomer,
  RevenueAnalytics,
  RfmAnalytics,
  RfmSegmentCustomers,
  SavedAddressArray,
  SavedAddresses,
  SlaAnalytics,
  SmsContact,
  SmsContactBulkResult,
  SmsContactBulkSmsRequest,
  SmsContactDeleted,
  SmsContactPage,
  SmsContactRequest,
  TimeToFirstOrder,
  ValidateReferralRequest,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getPutSmsContactsContactIdUrl = (contactId: number) => {
  return `/api/v1/sms-contacts/${contactId}`
}

/**
 * @summary Change an SMS contact
 */
export const putSmsContactsContactId = async (
  contactId: number,
  smsContactRequest: SmsContactRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<SmsContact> => {
  return customFetch<SmsContact>(getPutSmsContactsContactIdUrl(contactId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smsContactRequest),
  })
}

export const getPutSmsContactsContactIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSmsContactsContactId>>,
    TError,
    { contactId: number; data: SmsContactRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSmsContactsContactId>>,
  TError,
  { contactId: number; data: SmsContactRequest },
  TContext
> => {
  const mutationKey = ['putSmsContactsContactId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSmsContactsContactId>>,
    { contactId: number; data: SmsContactRequest }
  > = (props) => {
    const { contactId, data } = props ?? {}

    return putSmsContactsContactId(contactId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSmsContactsContactIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSmsContactsContactId>>
>
export type PutSmsContactsContactIdMutationBody = SmsContactRequest
export type PutSmsContactsContactIdMutationError = unknown

/**
 * @summary Change an SMS contact
 */
export const usePutSmsContactsContactId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSmsContactsContactId>>,
      TError,
      { contactId: number; data: SmsContactRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSmsContactsContactId>>,
  TError,
  { contactId: number; data: SmsContactRequest },
  TContext
> => {
  return useMutation(getPutSmsContactsContactIdMutationOptions(options), queryClient)
}
export const getDeleteSmsContactsContactIdUrl = (contactId: number) => {
  return `/api/v1/sms-contacts/${contactId}`
}

/**
 * @summary Remove an SMS contact
 */
export const deleteSmsContactsContactId = async (
  contactId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<SmsContactDeleted> => {
  return customFetch<SmsContactDeleted>(getDeleteSmsContactsContactIdUrl(contactId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteSmsContactsContactIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSmsContactsContactId>>,
    TError,
    { contactId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSmsContactsContactId>>,
  TError,
  { contactId: number },
  TContext
> => {
  const mutationKey = ['deleteSmsContactsContactId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSmsContactsContactId>>,
    { contactId: number }
  > = (props) => {
    const { contactId } = props ?? {}

    return deleteSmsContactsContactId(contactId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSmsContactsContactIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSmsContactsContactId>>
>

export type DeleteSmsContactsContactIdMutationError = unknown

/**
 * @summary Remove an SMS contact
 */
export const useDeleteSmsContactsContactId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSmsContactsContactId>>,
      TError,
      { contactId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSmsContactsContactId>>,
  TError,
  { contactId: number },
  TContext
> => {
  return useMutation(getDeleteSmsContactsContactIdMutationOptions(options), queryClient)
}
export const getGetSettingsLoyaltyUrl = () => {
  return `/api/v1/settings/loyalty`
}

/**
 * @summary The loyalty settings, with the active tiers
 */
export const getSettingsLoyalty = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<LoyaltySettingsWithLevels> => {
  return customFetch<LoyaltySettingsWithLevels>(getGetSettingsLoyaltyUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsLoyaltyQueryKey = () => {
  return [`/api/v1/settings/loyalty`] as const
}

export const getGetSettingsLoyaltyQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsLoyalty>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsLoyalty>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsLoyaltyQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsLoyalty>>> = ({ signal }) =>
    getSettingsLoyalty({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsLoyalty>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsLoyaltyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsLoyalty>>
>
export type GetSettingsLoyaltyQueryError = unknown

export function useGetSettingsLoyalty<
  TData = Awaited<ReturnType<typeof getSettingsLoyalty>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsLoyalty>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsLoyalty>>,
          TError,
          Awaited<ReturnType<typeof getSettingsLoyalty>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsLoyalty<
  TData = Awaited<ReturnType<typeof getSettingsLoyalty>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsLoyalty>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsLoyalty>>,
          TError,
          Awaited<ReturnType<typeof getSettingsLoyalty>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsLoyalty<
  TData = Awaited<ReturnType<typeof getSettingsLoyalty>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsLoyalty>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The loyalty settings, with the active tiers
 */

export function useGetSettingsLoyalty<
  TData = Awaited<ReturnType<typeof getSettingsLoyalty>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsLoyalty>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsLoyaltyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsLoyaltyUrl = () => {
  return `/api/v1/settings/loyalty`
}

/**
 * @summary Change the loyalty settings
 */
export const putSettingsLoyalty = async (
  putSettingsLoyaltyBody: PutSettingsLoyaltyBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<LoyaltySettings> => {
  return customFetch<LoyaltySettings>(getPutSettingsLoyaltyUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putSettingsLoyaltyBody),
  })
}

export const getPutSettingsLoyaltyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsLoyalty>>,
    TError,
    { data: PutSettingsLoyaltyBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsLoyalty>>,
  TError,
  { data: PutSettingsLoyaltyBody },
  TContext
> => {
  const mutationKey = ['putSettingsLoyalty']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsLoyalty>>,
    { data: PutSettingsLoyaltyBody }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsLoyalty(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsLoyaltyMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsLoyalty>>
>
export type PutSettingsLoyaltyMutationBody = PutSettingsLoyaltyBody
export type PutSettingsLoyaltyMutationError = unknown

/**
 * @summary Change the loyalty settings
 */
export const usePutSettingsLoyalty = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsLoyalty>>,
      TError,
      { data: PutSettingsLoyaltyBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsLoyalty>>,
  TError,
  { data: PutSettingsLoyaltyBody },
  TContext
> => {
  return useMutation(getPutSettingsLoyaltyMutationOptions(options), queryClient)
}
export const getGetLoyaltySettingsUrl = () => {
  return `/api/v1/loyalty/settings`
}

/**
 * @summary The loyalty settings on their own
 */
export const getLoyaltySettings = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<LoyaltySettings> => {
  return customFetch<LoyaltySettings>(getGetLoyaltySettingsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetLoyaltySettingsQueryKey = () => {
  return [`/api/v1/loyalty/settings`] as const
}

export const getGetLoyaltySettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoyaltySettings>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoyaltySettings>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetLoyaltySettingsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoyaltySettings>>> = ({ signal }) =>
    getLoyaltySettings({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLoyaltySettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoyaltySettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoyaltySettings>>
>
export type GetLoyaltySettingsQueryError = unknown

export function useGetLoyaltySettings<
  TData = Awaited<ReturnType<typeof getLoyaltySettings>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoyaltySettings>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoyaltySettings>>,
          TError,
          Awaited<ReturnType<typeof getLoyaltySettings>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltySettings<
  TData = Awaited<ReturnType<typeof getLoyaltySettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltySettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoyaltySettings>>,
          TError,
          Awaited<ReturnType<typeof getLoyaltySettings>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltySettings<
  TData = Awaited<ReturnType<typeof getLoyaltySettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoyaltySettings>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The loyalty settings on their own
 */

export function useGetLoyaltySettings<
  TData = Awaited<ReturnType<typeof getLoyaltySettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoyaltySettings>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLoyaltySettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutLoyaltySettingsUrl = () => {
  return `/api/v1/loyalty/settings`
}

/**
 * @summary Change the loyalty settings
 */
export const putLoyaltySettings = async (
  putLoyaltySettingsBody: PutLoyaltySettingsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<LoyaltySettings> => {
  return customFetch<LoyaltySettings>(getPutLoyaltySettingsUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putLoyaltySettingsBody),
  })
}

export const getPutLoyaltySettingsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putLoyaltySettings>>,
    TError,
    { data: PutLoyaltySettingsBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putLoyaltySettings>>,
  TError,
  { data: PutLoyaltySettingsBody },
  TContext
> => {
  const mutationKey = ['putLoyaltySettings']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putLoyaltySettings>>,
    { data: PutLoyaltySettingsBody }
  > = (props) => {
    const { data } = props ?? {}

    return putLoyaltySettings(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutLoyaltySettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putLoyaltySettings>>
>
export type PutLoyaltySettingsMutationBody = PutLoyaltySettingsBody
export type PutLoyaltySettingsMutationError = unknown

/**
 * @summary Change the loyalty settings
 */
export const usePutLoyaltySettings = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putLoyaltySettings>>,
      TError,
      { data: PutLoyaltySettingsBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putLoyaltySettings>>,
  TError,
  { data: PutLoyaltySettingsBody },
  TContext
> => {
  return useMutation(getPutLoyaltySettingsMutationOptions(options), queryClient)
}
export const getGetSmsContactsUrl = (params?: GetSmsContactsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/sms-contacts?${stringifiedParams}`
    : `/api/v1/sms-contacts`
}

/**
 * @summary The SMS contacts
 */
export const getSmsContacts = async (
  params?: GetSmsContactsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<SmsContactPage> => {
  return customFetch<SmsContactPage>(getGetSmsContactsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetSmsContactsQueryKey = (params?: GetSmsContactsParams) => {
  return [`/api/v1/sms-contacts`, ...(params ? [params] : [])] as const
}

export const getGetSmsContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSmsContacts>>,
  TError = unknown,
>(
  params?: GetSmsContactsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsContacts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSmsContactsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSmsContacts>>> = ({ signal }) =>
    getSmsContacts(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSmsContacts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSmsContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getSmsContacts>>>
export type GetSmsContactsQueryError = unknown

export function useGetSmsContacts<
  TData = Awaited<ReturnType<typeof getSmsContacts>>,
  TError = unknown,
>(
  params: undefined | GetSmsContactsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsContacts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmsContacts>>,
          TError,
          Awaited<ReturnType<typeof getSmsContacts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSmsContacts<
  TData = Awaited<ReturnType<typeof getSmsContacts>>,
  TError = unknown,
>(
  params?: GetSmsContactsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsContacts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSmsContacts>>,
          TError,
          Awaited<ReturnType<typeof getSmsContacts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSmsContacts<
  TData = Awaited<ReturnType<typeof getSmsContacts>>,
  TError = unknown,
>(
  params?: GetSmsContactsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsContacts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The SMS contacts
 */

export function useGetSmsContacts<
  TData = Awaited<ReturnType<typeof getSmsContacts>>,
  TError = unknown,
>(
  params?: GetSmsContactsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSmsContacts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSmsContactsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSmsContactsUrl = () => {
  return `/api/v1/sms-contacts`
}

/**
 * @summary Add an SMS contact
 */
export const postSmsContacts = async (
  smsContactRequest: SmsContactRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<SmsContact> => {
  return customFetch<SmsContact>(getPostSmsContactsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smsContactRequest),
  })
}

export const getPostSmsContactsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSmsContacts>>,
    TError,
    { data: SmsContactRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSmsContacts>>,
  TError,
  { data: SmsContactRequest },
  TContext
> => {
  const mutationKey = ['postSmsContacts']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSmsContacts>>,
    { data: SmsContactRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postSmsContacts(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSmsContactsMutationResult = NonNullable<Awaited<ReturnType<typeof postSmsContacts>>>
export type PostSmsContactsMutationBody = SmsContactRequest
export type PostSmsContactsMutationError = unknown

/**
 * @summary Add an SMS contact
 */
export const usePostSmsContacts = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSmsContacts>>,
      TError,
      { data: SmsContactRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSmsContacts>>,
  TError,
  { data: SmsContactRequest },
  TContext
> => {
  return useMutation(getPostSmsContactsMutationOptions(options), queryClient)
}
export const getPostSmsContactsBulkSmsUrl = () => {
  return `/api/v1/sms-contacts/bulk-sms`
}

/**
 * @summary Text the SMS contacts
 */
export const postSmsContactsBulkSms = async (
  smsContactBulkSmsRequest: SmsContactBulkSmsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<SmsContactBulkResult> => {
  return customFetch<SmsContactBulkResult>(getPostSmsContactsBulkSmsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(smsContactBulkSmsRequest),
  })
}

export const getPostSmsContactsBulkSmsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSmsContactsBulkSms>>,
    TError,
    { data: SmsContactBulkSmsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSmsContactsBulkSms>>,
  TError,
  { data: SmsContactBulkSmsRequest },
  TContext
> => {
  const mutationKey = ['postSmsContactsBulkSms']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSmsContactsBulkSms>>,
    { data: SmsContactBulkSmsRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postSmsContactsBulkSms(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSmsContactsBulkSmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSmsContactsBulkSms>>
>
export type PostSmsContactsBulkSmsMutationBody = SmsContactBulkSmsRequest
export type PostSmsContactsBulkSmsMutationError = unknown

/**
 * @summary Text the SMS contacts
 */
export const usePostSmsContactsBulkSms = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSmsContactsBulkSms>>,
      TError,
      { data: SmsContactBulkSmsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSmsContactsBulkSms>>,
  TError,
  { data: SmsContactBulkSmsRequest },
  TContext
> => {
  return useMutation(getPostSmsContactsBulkSmsMutationOptions(options), queryClient)
}
export const getPostSettingsLoyaltyTestEmailUrl = () => {
  return `/api/v1/settings/loyalty/test-email`
}

/**
 * Sends through the mail gateway directly and does **not** check `isEmailEnabled`, so a successful test does not mean the programme's e-mails are switched on.
 * @summary Send a test message to check the mail settings
 */
export const postSettingsLoyaltyTestEmail = async (
  loyaltyTestEmailRequest: LoyaltyTestEmailRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<LoyaltyTestEmailResult> => {
  return customFetch<LoyaltyTestEmailResult>(getPostSettingsLoyaltyTestEmailUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loyaltyTestEmailRequest),
  })
}

export const getPostSettingsLoyaltyTestEmailMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSettingsLoyaltyTestEmail>>,
    TError,
    { data: LoyaltyTestEmailRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSettingsLoyaltyTestEmail>>,
  TError,
  { data: LoyaltyTestEmailRequest },
  TContext
> => {
  const mutationKey = ['postSettingsLoyaltyTestEmail']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSettingsLoyaltyTestEmail>>,
    { data: LoyaltyTestEmailRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postSettingsLoyaltyTestEmail(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSettingsLoyaltyTestEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSettingsLoyaltyTestEmail>>
>
export type PostSettingsLoyaltyTestEmailMutationBody = LoyaltyTestEmailRequest
export type PostSettingsLoyaltyTestEmailMutationError = unknown

/**
 * @summary Send a test message to check the mail settings
 */
export const usePostSettingsLoyaltyTestEmail = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSettingsLoyaltyTestEmail>>,
      TError,
      { data: LoyaltyTestEmailRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettingsLoyaltyTestEmail>>,
  TError,
  { data: LoyaltyTestEmailRequest },
  TContext
> => {
  return useMutation(getPostSettingsLoyaltyTestEmailMutationOptions(options), queryClient)
}
export const getPostOrdersValidateReferralUrl = () => {
  return `/api/v1/orders/validate-referral`
}

/**
 * @summary Whether a referral code may be used on this order
 */
export const postOrdersValidateReferral = async (
  validateReferralRequest: ValidateReferralRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReferralValidation> => {
  return customFetch<ReferralValidation>(getPostOrdersValidateReferralUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(validateReferralRequest),
  })
}

export const getPostOrdersValidateReferralMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrdersValidateReferral>>,
    TError,
    { data: ValidateReferralRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrdersValidateReferral>>,
  TError,
  { data: ValidateReferralRequest },
  TContext
> => {
  const mutationKey = ['postOrdersValidateReferral']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrdersValidateReferral>>,
    { data: ValidateReferralRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postOrdersValidateReferral(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrdersValidateReferralMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrdersValidateReferral>>
>
export type PostOrdersValidateReferralMutationBody = ValidateReferralRequest
export type PostOrdersValidateReferralMutationError = unknown

/**
 * @summary Whether a referral code may be used on this order
 */
export const usePostOrdersValidateReferral = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrdersValidateReferral>>,
      TError,
      { data: ValidateReferralRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrdersValidateReferral>>,
  TError,
  { data: ValidateReferralRequest },
  TContext
> => {
  return useMutation(getPostOrdersValidateReferralMutationOptions(options), queryClient)
}
export const getPostLoyaltyNotifyPointsUrl = () => {
  return `/api/v1/loyalty/notify-points`
}

/**
 * @summary Award points and tell the customers
 */
export const postLoyaltyNotifyPoints = async (
  loyaltyNotifyPointsRequest: LoyaltyNotifyPointsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<LoyaltyNotifyPointsResult> => {
  return customFetch<LoyaltyNotifyPointsResult>(getPostLoyaltyNotifyPointsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loyaltyNotifyPointsRequest),
  })
}

export const getPostLoyaltyNotifyPointsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postLoyaltyNotifyPoints>>,
    TError,
    { data: LoyaltyNotifyPointsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postLoyaltyNotifyPoints>>,
  TError,
  { data: LoyaltyNotifyPointsRequest },
  TContext
> => {
  const mutationKey = ['postLoyaltyNotifyPoints']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postLoyaltyNotifyPoints>>,
    { data: LoyaltyNotifyPointsRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postLoyaltyNotifyPoints(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostLoyaltyNotifyPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postLoyaltyNotifyPoints>>
>
export type PostLoyaltyNotifyPointsMutationBody = LoyaltyNotifyPointsRequest
export type PostLoyaltyNotifyPointsMutationError = unknown

/**
 * @summary Award points and tell the customers
 */
export const usePostLoyaltyNotifyPoints = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postLoyaltyNotifyPoints>>,
      TError,
      { data: LoyaltyNotifyPointsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postLoyaltyNotifyPoints>>,
  TError,
  { data: LoyaltyNotifyPointsRequest },
  TContext
> => {
  return useMutation(getPostLoyaltyNotifyPointsMutationOptions(options), queryClient)
}
export const getGetLoyaltyLevelsUrl = () => {
  return `/api/v1/loyalty/levels`
}

/**
 * @summary Every tier, in display order
 */
export const getLoyaltyLevels = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<LoyaltyLevelRow[]> => {
  return customFetch<LoyaltyLevelRow[]>(getGetLoyaltyLevelsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetLoyaltyLevelsQueryKey = () => {
  return [`/api/v1/loyalty/levels`] as const
}

export const getGetLoyaltyLevelsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoyaltyLevels>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLevels>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetLoyaltyLevelsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoyaltyLevels>>> = ({ signal }) =>
    getLoyaltyLevels({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLoyaltyLevels>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoyaltyLevelsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoyaltyLevels>>>
export type GetLoyaltyLevelsQueryError = unknown

export function useGetLoyaltyLevels<
  TData = Awaited<ReturnType<typeof getLoyaltyLevels>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLevels>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoyaltyLevels>>,
          TError,
          Awaited<ReturnType<typeof getLoyaltyLevels>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyLevels<
  TData = Awaited<ReturnType<typeof getLoyaltyLevels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLevels>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoyaltyLevels>>,
          TError,
          Awaited<ReturnType<typeof getLoyaltyLevels>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyLevels<
  TData = Awaited<ReturnType<typeof getLoyaltyLevels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLevels>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every tier, in display order
 */

export function useGetLoyaltyLevels<
  TData = Awaited<ReturnType<typeof getLoyaltyLevels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyLevels>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLoyaltyLevelsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostLoyaltyLevelsUrl = () => {
  return `/api/v1/loyalty/levels`
}

/**
 * @summary Add a tier
 */
export const postLoyaltyLevels = async (
  postLoyaltyLevelsBody: PostLoyaltyLevelsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<LoyaltyLevelRow> => {
  return customFetch<LoyaltyLevelRow>(getPostLoyaltyLevelsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postLoyaltyLevelsBody),
  })
}

export const getPostLoyaltyLevelsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postLoyaltyLevels>>,
    TError,
    { data: PostLoyaltyLevelsBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postLoyaltyLevels>>,
  TError,
  { data: PostLoyaltyLevelsBody },
  TContext
> => {
  const mutationKey = ['postLoyaltyLevels']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postLoyaltyLevels>>,
    { data: PostLoyaltyLevelsBody }
  > = (props) => {
    const { data } = props ?? {}

    return postLoyaltyLevels(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostLoyaltyLevelsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postLoyaltyLevels>>
>
export type PostLoyaltyLevelsMutationBody = PostLoyaltyLevelsBody
export type PostLoyaltyLevelsMutationError = unknown

/**
 * @summary Add a tier
 */
export const usePostLoyaltyLevels = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postLoyaltyLevels>>,
      TError,
      { data: PostLoyaltyLevelsBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postLoyaltyLevels>>,
  TError,
  { data: PostLoyaltyLevelsBody },
  TContext
> => {
  return useMutation(getPostLoyaltyLevelsMutationOptions(options), queryClient)
}
export const getPostLoyaltyLevelsReorderUrl = () => {
  return `/api/v1/loyalty/levels/reorder`
}

/**
 * @summary Put the tiers in a new order
 */
export const postLoyaltyLevelsReorder = async (
  loyaltyLevelReorderRequest: LoyaltyLevelReorderRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getPostLoyaltyLevelsReorderUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loyaltyLevelReorderRequest),
  })
}

export const getPostLoyaltyLevelsReorderMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postLoyaltyLevelsReorder>>,
    TError,
    { data: LoyaltyLevelReorderRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postLoyaltyLevelsReorder>>,
  TError,
  { data: LoyaltyLevelReorderRequest },
  TContext
> => {
  const mutationKey = ['postLoyaltyLevelsReorder']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postLoyaltyLevelsReorder>>,
    { data: LoyaltyLevelReorderRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postLoyaltyLevelsReorder(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostLoyaltyLevelsReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof postLoyaltyLevelsReorder>>
>
export type PostLoyaltyLevelsReorderMutationBody = LoyaltyLevelReorderRequest
export type PostLoyaltyLevelsReorderMutationError = unknown

/**
 * @summary Put the tiers in a new order
 */
export const usePostLoyaltyLevelsReorder = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postLoyaltyLevelsReorder>>,
      TError,
      { data: LoyaltyLevelReorderRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postLoyaltyLevelsReorder>>,
  TError,
  { data: LoyaltyLevelReorderRequest },
  TContext
> => {
  return useMutation(getPostLoyaltyLevelsReorderMutationOptions(options), queryClient)
}
export const getPostLoyaltyBulkEmailUrl = () => {
  return `/api/v1/loyalty/bulk-email`
}

/**
 * @summary E-mail a list of customers, or every loyalty member
 */
export const postLoyaltyBulkEmail = async (
  customerSendEmailRequest: CustomerSendEmailRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerBulkSendResult> => {
  return customFetch<CustomerBulkSendResult>(getPostLoyaltyBulkEmailUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerSendEmailRequest),
  })
}

export const getPostLoyaltyBulkEmailMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postLoyaltyBulkEmail>>,
    TError,
    { data: CustomerSendEmailRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postLoyaltyBulkEmail>>,
  TError,
  { data: CustomerSendEmailRequest },
  TContext
> => {
  const mutationKey = ['postLoyaltyBulkEmail']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postLoyaltyBulkEmail>>,
    { data: CustomerSendEmailRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postLoyaltyBulkEmail(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostLoyaltyBulkEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof postLoyaltyBulkEmail>>
>
export type PostLoyaltyBulkEmailMutationBody = CustomerSendEmailRequest
export type PostLoyaltyBulkEmailMutationError = unknown

/**
 * @summary E-mail a list of customers, or every loyalty member
 */
export const usePostLoyaltyBulkEmail = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postLoyaltyBulkEmail>>,
      TError,
      { data: CustomerSendEmailRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postLoyaltyBulkEmail>>,
  TError,
  { data: CustomerSendEmailRequest },
  TContext
> => {
  return useMutation(getPostLoyaltyBulkEmailMutationOptions(options), queryClient)
}
export const getGetCustomersUrl = (params?: GetCustomersParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/customers?${stringifiedParams}`
    : `/api/v1/customers`
}

/**
 * @summary The customers, filtered and paged
 */
export const getCustomers = async (
  params?: GetCustomersParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerPage> => {
  return customFetch<CustomerPage>(getGetCustomersUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomersQueryKey = (params?: GetCustomersParams) => {
  return [`/api/v1/customers`, ...(params ? [params] : [])] as const
}

export const getGetCustomersQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomers>>,
  TError = unknown,
>(
  params?: GetCustomersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomersQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomers>>> = ({ signal }) =>
    getCustomers(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomers>>>
export type GetCustomersQueryError = unknown

export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = unknown>(
  params: undefined | GetCustomersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomers>>,
          TError,
          Awaited<ReturnType<typeof getCustomers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = unknown>(
  params?: GetCustomersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomers>>,
          TError,
          Awaited<ReturnType<typeof getCustomers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = unknown>(
  params?: GetCustomersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The customers, filtered and paged
 */

export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = unknown>(
  params?: GetCustomersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomersQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostCustomersUrl = () => {
  return `/api/v1/customers`
}

/**
 * @summary Add a customer by hand
 */
export const postCustomers = async (
  customerCreateRequest: CustomerCreateRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerBrief> => {
  return customFetch<CustomerBrief>(getPostCustomersUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerCreateRequest),
  })
}

export const getPostCustomersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomers>>,
    TError,
    { data: CustomerCreateRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomers>>,
  TError,
  { data: CustomerCreateRequest },
  TContext
> => {
  const mutationKey = ['postCustomers']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomers>>,
    { data: CustomerCreateRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomers(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomersMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomers>>>
export type PostCustomersMutationBody = CustomerCreateRequest
export type PostCustomersMutationError = unknown

/**
 * @summary Add a customer by hand
 */
export const usePostCustomers = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomers>>,
      TError,
      { data: CustomerCreateRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomers>>,
  TError,
  { data: CustomerCreateRequest },
  TContext
> => {
  return useMutation(getPostCustomersMutationOptions(options), queryClient)
}
export const getPostCustomersCustomerIdAnonymizeUrl = (customerId: number) => {
  return `/api/v1/customers/${customerId}/anonymize`
}

/**
 * @summary Anonymise a customer
 */
export const postCustomersCustomerIdAnonymize = async (
  customerId: number,
  customerAnonymizeRequest?: CustomerAnonymizeRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerAnonymized> => {
  return customFetch<CustomerAnonymized>(getPostCustomersCustomerIdAnonymizeUrl(customerId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerAnonymizeRequest),
  })
}

export const getPostCustomersCustomerIdAnonymizeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomersCustomerIdAnonymize>>,
    TError,
    { customerId: number; data?: CustomerAnonymizeRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomersCustomerIdAnonymize>>,
  TError,
  { customerId: number; data?: CustomerAnonymizeRequest },
  TContext
> => {
  const mutationKey = ['postCustomersCustomerIdAnonymize']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomersCustomerIdAnonymize>>,
    { customerId: number; data?: CustomerAnonymizeRequest }
  > = (props) => {
    const { customerId, data } = props ?? {}

    return postCustomersCustomerIdAnonymize(customerId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomersCustomerIdAnonymizeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomersCustomerIdAnonymize>>
>
export type PostCustomersCustomerIdAnonymizeMutationBody = CustomerAnonymizeRequest | undefined
export type PostCustomersCustomerIdAnonymizeMutationError = unknown

/**
 * @summary Anonymise a customer
 */
export const usePostCustomersCustomerIdAnonymize = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomersCustomerIdAnonymize>>,
      TError,
      { customerId: number; data?: CustomerAnonymizeRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomersCustomerIdAnonymize>>,
  TError,
  { customerId: number; data?: CustomerAnonymizeRequest },
  TContext
> => {
  return useMutation(getPostCustomersCustomerIdAnonymizeMutationOptions(options), queryClient)
}
export const getPostCustomersSendEmailUrl = () => {
  return `/api/v1/customers/send-email`
}

/**
 * @summary E-mail a list of customers, or every loyalty member
 */
export const postCustomersSendEmail = async (
  customerSendEmailRequest: CustomerSendEmailRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerBulkSendResult> => {
  return customFetch<CustomerBulkSendResult>(getPostCustomersSendEmailUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerSendEmailRequest),
  })
}

export const getPostCustomersSendEmailMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomersSendEmail>>,
    TError,
    { data: CustomerSendEmailRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomersSendEmail>>,
  TError,
  { data: CustomerSendEmailRequest },
  TContext
> => {
  const mutationKey = ['postCustomersSendEmail']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomersSendEmail>>,
    { data: CustomerSendEmailRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomersSendEmail(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomersSendEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomersSendEmail>>
>
export type PostCustomersSendEmailMutationBody = CustomerSendEmailRequest
export type PostCustomersSendEmailMutationError = unknown

/**
 * @summary E-mail a list of customers, or every loyalty member
 */
export const usePostCustomersSendEmail = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomersSendEmail>>,
      TError,
      { data: CustomerSendEmailRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomersSendEmail>>,
  TError,
  { data: CustomerSendEmailRequest },
  TContext
> => {
  return useMutation(getPostCustomersSendEmailMutationOptions(options), queryClient)
}
export const getPostCustomersRegisterUrl = () => {
  return `/api/v1/customers/register`
}

/**
 * @summary Record a customer from checkout
 */
export const postCustomersRegister = async (
  customerRegisterFromCheckoutRequest: CustomerRegisterFromCheckoutRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<RegisteredCustomer> => {
  return customFetch<RegisteredCustomer>(getPostCustomersRegisterUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerRegisterFromCheckoutRequest),
  })
}

export const getPostCustomersRegisterMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomersRegister>>,
    TError,
    { data: CustomerRegisterFromCheckoutRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomersRegister>>,
  TError,
  { data: CustomerRegisterFromCheckoutRequest },
  TContext
> => {
  const mutationKey = ['postCustomersRegister']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomersRegister>>,
    { data: CustomerRegisterFromCheckoutRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomersRegister(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomersRegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomersRegister>>
>
export type PostCustomersRegisterMutationBody = CustomerRegisterFromCheckoutRequest
export type PostCustomersRegisterMutationError = unknown

/**
 * @summary Record a customer from checkout
 */
export const usePostCustomersRegister = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomersRegister>>,
      TError,
      { data: CustomerRegisterFromCheckoutRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomersRegister>>,
  TError,
  { data: CustomerRegisterFromCheckoutRequest },
  TContext
> => {
  return useMutation(getPostCustomersRegisterMutationOptions(options), queryClient)
}
export const getPostCustomersRedeemPointsUrl = () => {
  return `/api/v1/customers/redeem-points`
}

/**
 * @summary What redeeming points would be worth
 */
export const postCustomersRedeemPoints = async (
  redeemPointsRequest: RedeemPointsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<RedeemPointsResponse> => {
  return customFetch<RedeemPointsResponse>(getPostCustomersRedeemPointsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(redeemPointsRequest),
  })
}

export const getPostCustomersRedeemPointsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomersRedeemPoints>>,
    TError,
    { data: RedeemPointsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomersRedeemPoints>>,
  TError,
  { data: RedeemPointsRequest },
  TContext
> => {
  const mutationKey = ['postCustomersRedeemPoints']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomersRedeemPoints>>,
    { data: RedeemPointsRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomersRedeemPoints(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomersRedeemPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomersRedeemPoints>>
>
export type PostCustomersRedeemPointsMutationBody = RedeemPointsRequest
export type PostCustomersRedeemPointsMutationError = unknown

/**
 * @summary What redeeming points would be worth
 */
export const usePostCustomersRedeemPoints = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomersRedeemPoints>>,
      TError,
      { data: RedeemPointsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomersRedeemPoints>>,
  TError,
  { data: RedeemPointsRequest },
  TContext
> => {
  return useMutation(getPostCustomersRedeemPointsMutationOptions(options), queryClient)
}
export const getPostCustomersBulkSmsUrl = () => {
  return `/api/v1/customers/bulk-sms`
}

/**
 * @summary Text a list of customers who have consented
 */
export const postCustomersBulkSms = async (
  customerBulkSmsRequest: CustomerBulkSmsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerBulkSendResult> => {
  return customFetch<CustomerBulkSendResult>(getPostCustomersBulkSmsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerBulkSmsRequest),
  })
}

export const getPostCustomersBulkSmsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomersBulkSms>>,
    TError,
    { data: CustomerBulkSmsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomersBulkSms>>,
  TError,
  { data: CustomerBulkSmsRequest },
  TContext
> => {
  const mutationKey = ['postCustomersBulkSms']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomersBulkSms>>,
    { data: CustomerBulkSmsRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomersBulkSms(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomersBulkSmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomersBulkSms>>
>
export type PostCustomersBulkSmsMutationBody = CustomerBulkSmsRequest
export type PostCustomersBulkSmsMutationError = unknown

/**
 * @summary Text a list of customers who have consented
 */
export const usePostCustomersBulkSms = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomersBulkSms>>,
      TError,
      { data: CustomerBulkSmsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomersBulkSms>>,
  TError,
  { data: CustomerBulkSmsRequest },
  TContext
> => {
  return useMutation(getPostCustomersBulkSmsMutationOptions(options), queryClient)
}
export const getPostCustomersBulkPushUrl = () => {
  return `/api/v1/customers/bulk-push`
}

/**
 * @summary Push a message to a list of customers
 */
export const postCustomersBulkPush = async (
  customerBulkPushRequest: CustomerBulkPushRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerBulkPushResult> => {
  return customFetch<CustomerBulkPushResult>(getPostCustomersBulkPushUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerBulkPushRequest),
  })
}

export const getPostCustomersBulkPushMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomersBulkPush>>,
    TError,
    { data: CustomerBulkPushRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomersBulkPush>>,
  TError,
  { data: CustomerBulkPushRequest },
  TContext
> => {
  const mutationKey = ['postCustomersBulkPush']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomersBulkPush>>,
    { data: CustomerBulkPushRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomersBulkPush(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomersBulkPushMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomersBulkPush>>
>
export type PostCustomersBulkPushMutationBody = CustomerBulkPushRequest
export type PostCustomersBulkPushMutationError = unknown

/**
 * @summary Push a message to a list of customers
 */
export const usePostCustomersBulkPush = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomersBulkPush>>,
      TError,
      { data: CustomerBulkPushRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomersBulkPush>>,
  TError,
  { data: CustomerBulkPushRequest },
  TContext
> => {
  return useMutation(getPostCustomersBulkPushMutationOptions(options), queryClient)
}
export const getPostCustomersBulkPointsUrl = () => {
  return `/api/v1/customers/bulk-points`
}

/**
 * @summary Grant or remove points across a list of customers
 */
export const postCustomersBulkPoints = async (
  customerBulkPointsRequest: CustomerBulkPointsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerBulkPointsResult> => {
  return customFetch<CustomerBulkPointsResult>(getPostCustomersBulkPointsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerBulkPointsRequest),
  })
}

export const getPostCustomersBulkPointsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomersBulkPoints>>,
    TError,
    { data: CustomerBulkPointsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomersBulkPoints>>,
  TError,
  { data: CustomerBulkPointsRequest },
  TContext
> => {
  const mutationKey = ['postCustomersBulkPoints']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomersBulkPoints>>,
    { data: CustomerBulkPointsRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomersBulkPoints(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomersBulkPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomersBulkPoints>>
>
export type PostCustomersBulkPointsMutationBody = CustomerBulkPointsRequest
export type PostCustomersBulkPointsMutationError = unknown

/**
 * @summary Grant or remove points across a list of customers
 */
export const usePostCustomersBulkPoints = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomersBulkPoints>>,
      TError,
      { data: CustomerBulkPointsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomersBulkPoints>>,
  TError,
  { data: CustomerBulkPointsRequest },
  TContext
> => {
  return useMutation(getPostCustomersBulkPointsMutationOptions(options), queryClient)
}
export const getPostCustomersBulkImportUrl = () => {
  return `/api/v1/customers/bulk-import`
}

/**
 * @summary Import a list of customers, skipping those already on file
 */
export const postCustomersBulkImport = async (
  customerBulkImportRequest: CustomerBulkImportRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerBulkImportResult> => {
  return customFetch<CustomerBulkImportResult>(getPostCustomersBulkImportUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerBulkImportRequest),
  })
}

export const getPostCustomersBulkImportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomersBulkImport>>,
    TError,
    { data: CustomerBulkImportRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomersBulkImport>>,
  TError,
  { data: CustomerBulkImportRequest },
  TContext
> => {
  const mutationKey = ['postCustomersBulkImport']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomersBulkImport>>,
    { data: CustomerBulkImportRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomersBulkImport(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomersBulkImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomersBulkImport>>
>
export type PostCustomersBulkImportMutationBody = CustomerBulkImportRequest
export type PostCustomersBulkImportMutationError = unknown

/**
 * @summary Import a list of customers, skipping those already on file
 */
export const usePostCustomersBulkImport = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomersBulkImport>>,
      TError,
      { data: CustomerBulkImportRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomersBulkImport>>,
  TError,
  { data: CustomerBulkImportRequest },
  TContext
> => {
  return useMutation(getPostCustomersBulkImportMutationOptions(options), queryClient)
}
export const getPostCustomersBulkDeleteUrl = () => {
  return `/api/v1/customers/bulk-delete`
}

/**
 * @summary Delete a list of customers and everything that hangs off them
 */
export const postCustomersBulkDelete = async (
  customerBulkIdsRequest: CustomerBulkIdsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerBulkDeleteResult> => {
  return customFetch<CustomerBulkDeleteResult>(getPostCustomersBulkDeleteUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerBulkIdsRequest),
  })
}

export const getPostCustomersBulkDeleteMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomersBulkDelete>>,
    TError,
    { data: CustomerBulkIdsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomersBulkDelete>>,
  TError,
  { data: CustomerBulkIdsRequest },
  TContext
> => {
  const mutationKey = ['postCustomersBulkDelete']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomersBulkDelete>>,
    { data: CustomerBulkIdsRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomersBulkDelete(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomersBulkDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomersBulkDelete>>
>
export type PostCustomersBulkDeleteMutationBody = CustomerBulkIdsRequest
export type PostCustomersBulkDeleteMutationError = unknown

/**
 * @summary Delete a list of customers and everything that hangs off them
 */
export const usePostCustomersBulkDelete = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomersBulkDelete>>,
      TError,
      { data: CustomerBulkIdsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomersBulkDelete>>,
  TError,
  { data: CustomerBulkIdsRequest },
  TContext
> => {
  return useMutation(getPostCustomersBulkDeleteMutationOptions(options), queryClient)
}
export const getPostCustomersBulkAnonymizeUrl = () => {
  return `/api/v1/customers/bulk-anonymize`
}

/**
 * @summary Start anonymising a list of customers
 */
export const postCustomersBulkAnonymize = async (
  customerBulkAnonymizeRequest: CustomerBulkAnonymizeRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerAnonymizeJob> => {
  return customFetch<CustomerAnonymizeJob>(getPostCustomersBulkAnonymizeUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerBulkAnonymizeRequest),
  })
}

export const getPostCustomersBulkAnonymizeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomersBulkAnonymize>>,
    TError,
    { data: CustomerBulkAnonymizeRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomersBulkAnonymize>>,
  TError,
  { data: CustomerBulkAnonymizeRequest },
  TContext
> => {
  const mutationKey = ['postCustomersBulkAnonymize']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomersBulkAnonymize>>,
    { data: CustomerBulkAnonymizeRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomersBulkAnonymize(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomersBulkAnonymizeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomersBulkAnonymize>>
>
export type PostCustomersBulkAnonymizeMutationBody = CustomerBulkAnonymizeRequest
export type PostCustomersBulkAnonymizeMutationError = unknown

/**
 * @summary Start anonymising a list of customers
 */
export const usePostCustomersBulkAnonymize = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomersBulkAnonymize>>,
      TError,
      { data: CustomerBulkAnonymizeRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomersBulkAnonymize>>,
  TError,
  { data: CustomerBulkAnonymizeRequest },
  TContext
> => {
  return useMutation(getPostCustomersBulkAnonymizeMutationOptions(options), queryClient)
}
export const getPostCustomersBackfillLevelsUrl = () => {
  return `/api/v1/customers/backfill-levels`
}

/**
 * @summary Recompute every customer's tier from their order count
 */
export const postCustomersBackfillLevels = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<Backfill> => {
  return customFetch<Backfill>(getPostCustomersBackfillLevelsUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostCustomersBackfillLevelsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomersBackfillLevels>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomersBackfillLevels>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postCustomersBackfillLevels']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomersBackfillLevels>>,
    void
  > = () => {
    return postCustomersBackfillLevels(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomersBackfillLevelsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomersBackfillLevels>>
>

export type PostCustomersBackfillLevelsMutationError = unknown

/**
 * @summary Recompute every customer's tier from their order count
 */
export const usePostCustomersBackfillLevels = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomersBackfillLevels>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomersBackfillLevels>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostCustomersBackfillLevelsMutationOptions(options), queryClient)
}
export const getPostCustomerAuthResetPasswordUrl = () => {
  return `/api/v1/customer-auth/reset-password`
}

/**
 * @summary Set a new password from a reset link
 */
export const postCustomerAuthResetPassword = async (
  customerResetPasswordRequest: CustomerResetPasswordRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerPasswordReset> => {
  return customFetch<CustomerPasswordReset>(getPostCustomerAuthResetPasswordUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerResetPasswordRequest),
  })
}

export const getPostCustomerAuthResetPasswordMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomerAuthResetPassword>>,
    TError,
    { data: CustomerResetPasswordRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomerAuthResetPassword>>,
  TError,
  { data: CustomerResetPasswordRequest },
  TContext
> => {
  const mutationKey = ['postCustomerAuthResetPassword']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomerAuthResetPassword>>,
    { data: CustomerResetPasswordRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomerAuthResetPassword(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomerAuthResetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomerAuthResetPassword>>
>
export type PostCustomerAuthResetPasswordMutationBody = CustomerResetPasswordRequest
export type PostCustomerAuthResetPasswordMutationError = unknown

/**
 * @summary Set a new password from a reset link
 */
export const usePostCustomerAuthResetPassword = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomerAuthResetPassword>>,
      TError,
      { data: CustomerResetPasswordRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomerAuthResetPassword>>,
  TError,
  { data: CustomerResetPasswordRequest },
  TContext
> => {
  return useMutation(getPostCustomerAuthResetPasswordMutationOptions(options), queryClient)
}
export const getPostCustomerAuthRegisterUrl = () => {
  return `/api/v1/customer-auth/register`
}

/**
 * @summary Create a customer account
 */
export const postCustomerAuthRegister = async (
  customerRegisterRequest: CustomerRegisterRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerSession> => {
  return customFetch<CustomerSession>(getPostCustomerAuthRegisterUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerRegisterRequest),
  })
}

export const getPostCustomerAuthRegisterMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomerAuthRegister>>,
    TError,
    { data: CustomerRegisterRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomerAuthRegister>>,
  TError,
  { data: CustomerRegisterRequest },
  TContext
> => {
  const mutationKey = ['postCustomerAuthRegister']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomerAuthRegister>>,
    { data: CustomerRegisterRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomerAuthRegister(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomerAuthRegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomerAuthRegister>>
>
export type PostCustomerAuthRegisterMutationBody = CustomerRegisterRequest
export type PostCustomerAuthRegisterMutationError = unknown

/**
 * @summary Create a customer account
 */
export const usePostCustomerAuthRegister = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomerAuthRegister>>,
      TError,
      { data: CustomerRegisterRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomerAuthRegister>>,
  TError,
  { data: CustomerRegisterRequest },
  TContext
> => {
  return useMutation(getPostCustomerAuthRegisterMutationOptions(options), queryClient)
}
export const getPostCustomerAuthMyOrdersOrderIdCancelUrl = (orderId: number) => {
  return `/api/v1/customer-auth/my-orders/${orderId}/cancel`
}

/**
 * @summary Cancel an order the kitchen has not started
 */
export const postCustomerAuthMyOrdersOrderIdCancel = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerDeleted> => {
  return customFetch<CustomerDeleted>(getPostCustomerAuthMyOrdersOrderIdCancelUrl(orderId), {
    ...options,
    method: 'POST',
  })
}

export const getPostCustomerAuthMyOrdersOrderIdCancelMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomerAuthMyOrdersOrderIdCancel>>,
    TError,
    { orderId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomerAuthMyOrdersOrderIdCancel>>,
  TError,
  { orderId: number },
  TContext
> => {
  const mutationKey = ['postCustomerAuthMyOrdersOrderIdCancel']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomerAuthMyOrdersOrderIdCancel>>,
    { orderId: number }
  > = (props) => {
    const { orderId } = props ?? {}

    return postCustomerAuthMyOrdersOrderIdCancel(orderId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomerAuthMyOrdersOrderIdCancelMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomerAuthMyOrdersOrderIdCancel>>
>

export type PostCustomerAuthMyOrdersOrderIdCancelMutationError = unknown

/**
 * @summary Cancel an order the kitchen has not started
 */
export const usePostCustomerAuthMyOrdersOrderIdCancel = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomerAuthMyOrdersOrderIdCancel>>,
      TError,
      { orderId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomerAuthMyOrdersOrderIdCancel>>,
  TError,
  { orderId: number },
  TContext
> => {
  return useMutation(getPostCustomerAuthMyOrdersOrderIdCancelMutationOptions(options), queryClient)
}
export const getGetCustomerAuthMeSavedAddressesUrl = () => {
  return `/api/v1/customer-auth/me/saved-addresses`
}

/**
 * @summary The addresses this customer can deliver to
 */
export const getCustomerAuthMeSavedAddresses = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<SavedAddresses> => {
  return customFetch<SavedAddresses>(getGetCustomerAuthMeSavedAddressesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomerAuthMeSavedAddressesQueryKey = () => {
  return [`/api/v1/customer-auth/me/saved-addresses`] as const
}

export const getGetCustomerAuthMeSavedAddressesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomerAuthMeSavedAddressesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>> = ({
    signal,
  }) => getCustomerAuthMeSavedAddresses({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerAuthMeSavedAddressesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>
>
export type GetCustomerAuthMeSavedAddressesQueryError = unknown

export function useGetCustomerAuthMeSavedAddresses<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMeSavedAddresses<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMeSavedAddresses<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The addresses this customer can deliver to
 */

export function useGetCustomerAuthMeSavedAddresses<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeSavedAddresses>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomerAuthMeSavedAddressesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostCustomerAuthMeSavedAddressesUrl = () => {
  return `/api/v1/customer-auth/me/saved-addresses`
}

/**
 * @summary Save an address
 */
export const postCustomerAuthMeSavedAddresses = async (
  customerSaveAddressRequest: CustomerSaveAddressRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<SavedAddressArray> => {
  return customFetch<SavedAddressArray>(getPostCustomerAuthMeSavedAddressesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerSaveAddressRequest),
  })
}

export const getPostCustomerAuthMeSavedAddressesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomerAuthMeSavedAddresses>>,
    TError,
    { data: CustomerSaveAddressRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomerAuthMeSavedAddresses>>,
  TError,
  { data: CustomerSaveAddressRequest },
  TContext
> => {
  const mutationKey = ['postCustomerAuthMeSavedAddresses']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomerAuthMeSavedAddresses>>,
    { data: CustomerSaveAddressRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomerAuthMeSavedAddresses(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomerAuthMeSavedAddressesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomerAuthMeSavedAddresses>>
>
export type PostCustomerAuthMeSavedAddressesMutationBody = CustomerSaveAddressRequest
export type PostCustomerAuthMeSavedAddressesMutationError = unknown

/**
 * @summary Save an address
 */
export const usePostCustomerAuthMeSavedAddresses = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomerAuthMeSavedAddresses>>,
      TError,
      { data: CustomerSaveAddressRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomerAuthMeSavedAddresses>>,
  TError,
  { data: CustomerSaveAddressRequest },
  TContext
> => {
  return useMutation(getPostCustomerAuthMeSavedAddressesMutationOptions(options), queryClient)
}
export const getPostCustomerAuthMeRequestDeletionUrl = () => {
  return `/api/v1/customer-auth/me/request-deletion`
}

/**
 * @summary Ask for this account to be deleted
 */
export const postCustomerAuthMeRequestDeletion = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerDeletionRequested> => {
  return customFetch<CustomerDeletionRequested>(getPostCustomerAuthMeRequestDeletionUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostCustomerAuthMeRequestDeletionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomerAuthMeRequestDeletion>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomerAuthMeRequestDeletion>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postCustomerAuthMeRequestDeletion']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomerAuthMeRequestDeletion>>,
    void
  > = () => {
    return postCustomerAuthMeRequestDeletion(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomerAuthMeRequestDeletionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomerAuthMeRequestDeletion>>
>

export type PostCustomerAuthMeRequestDeletionMutationError = unknown

/**
 * @summary Ask for this account to be deleted
 */
export const usePostCustomerAuthMeRequestDeletion = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomerAuthMeRequestDeletion>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomerAuthMeRequestDeletion>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostCustomerAuthMeRequestDeletionMutationOptions(options), queryClient)
}
export const getDeleteCustomerAuthMeRequestDeletionUrl = () => {
  return `/api/v1/customer-auth/me/request-deletion`
}

/**
 * @summary Withdraw a deletion request
 */
export const deleteCustomerAuthMeRequestDeletion = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerDeletionWithdrawn> => {
  return customFetch<CustomerDeletionWithdrawn>(getDeleteCustomerAuthMeRequestDeletionUrl(), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteCustomerAuthMeRequestDeletionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomerAuthMeRequestDeletion>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomerAuthMeRequestDeletion>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteCustomerAuthMeRequestDeletion']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomerAuthMeRequestDeletion>>,
    void
  > = () => {
    return deleteCustomerAuthMeRequestDeletion(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteCustomerAuthMeRequestDeletionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomerAuthMeRequestDeletion>>
>

export type DeleteCustomerAuthMeRequestDeletionMutationError = unknown

/**
 * @summary Withdraw a deletion request
 */
export const useDeleteCustomerAuthMeRequestDeletion = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCustomerAuthMeRequestDeletion>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomerAuthMeRequestDeletion>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDeleteCustomerAuthMeRequestDeletionMutationOptions(options), queryClient)
}
export const getGetCustomerAuthMePushSubscriptionsUrl = () => {
  return `/api/v1/customer-auth/me/push-subscriptions`
}

/**
 * @summary The browsers registered for this customer
 */
export const getCustomerAuthMePushSubscriptions = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PushSubscriptions> => {
  return customFetch<PushSubscriptions>(getGetCustomerAuthMePushSubscriptionsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomerAuthMePushSubscriptionsQueryKey = () => {
  return [`/api/v1/customer-auth/me/push-subscriptions`] as const
}

export const getGetCustomerAuthMePushSubscriptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomerAuthMePushSubscriptionsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>> = ({
    signal,
  }) => getCustomerAuthMePushSubscriptions({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerAuthMePushSubscriptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>
>
export type GetCustomerAuthMePushSubscriptionsQueryError = unknown

export function useGetCustomerAuthMePushSubscriptions<
  TData = Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMePushSubscriptions<
  TData = Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMePushSubscriptions<
  TData = Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The browsers registered for this customer
 */

export function useGetCustomerAuthMePushSubscriptions<
  TData = Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMePushSubscriptions>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomerAuthMePushSubscriptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostCustomerAuthMePushSubscriptionsUrl = () => {
  return `/api/v1/customer-auth/me/push-subscriptions`
}

/**
 * @summary Register this browser for push
 */
export const postCustomerAuthMePushSubscriptions = async (
  pushSubscribeRequest: PushSubscribeRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerPushSubscription> => {
  return customFetch<CustomerPushSubscription>(getPostCustomerAuthMePushSubscriptionsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pushSubscribeRequest),
  })
}

export const getPostCustomerAuthMePushSubscriptionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomerAuthMePushSubscriptions>>,
    TError,
    { data: PushSubscribeRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomerAuthMePushSubscriptions>>,
  TError,
  { data: PushSubscribeRequest },
  TContext
> => {
  const mutationKey = ['postCustomerAuthMePushSubscriptions']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomerAuthMePushSubscriptions>>,
    { data: PushSubscribeRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomerAuthMePushSubscriptions(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomerAuthMePushSubscriptionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomerAuthMePushSubscriptions>>
>
export type PostCustomerAuthMePushSubscriptionsMutationBody = PushSubscribeRequest
export type PostCustomerAuthMePushSubscriptionsMutationError = unknown

/**
 * @summary Register this browser for push
 */
export const usePostCustomerAuthMePushSubscriptions = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomerAuthMePushSubscriptions>>,
      TError,
      { data: PushSubscribeRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomerAuthMePushSubscriptions>>,
  TError,
  { data: PushSubscribeRequest },
  TContext
> => {
  return useMutation(getPostCustomerAuthMePushSubscriptionsMutationOptions(options), queryClient)
}
export const getDeleteCustomerAuthMePushSubscriptionsUrl = () => {
  return `/api/v1/customer-auth/me/push-subscriptions`
}

/**
 * @summary Stop pushing to this browser
 */
export const deleteCustomerAuthMePushSubscriptions = async (
  pushUnsubscribeRequest: PushUnsubscribeRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerPushSubscription> => {
  return customFetch<CustomerPushSubscription>(getDeleteCustomerAuthMePushSubscriptionsUrl(), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pushUnsubscribeRequest),
  })
}

export const getDeleteCustomerAuthMePushSubscriptionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomerAuthMePushSubscriptions>>,
    TError,
    { data: PushUnsubscribeRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomerAuthMePushSubscriptions>>,
  TError,
  { data: PushUnsubscribeRequest },
  TContext
> => {
  const mutationKey = ['deleteCustomerAuthMePushSubscriptions']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomerAuthMePushSubscriptions>>,
    { data: PushUnsubscribeRequest }
  > = (props) => {
    const { data } = props ?? {}

    return deleteCustomerAuthMePushSubscriptions(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteCustomerAuthMePushSubscriptionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomerAuthMePushSubscriptions>>
>
export type DeleteCustomerAuthMePushSubscriptionsMutationBody = PushUnsubscribeRequest
export type DeleteCustomerAuthMePushSubscriptionsMutationError = unknown

/**
 * @summary Stop pushing to this browser
 */
export const useDeleteCustomerAuthMePushSubscriptions = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCustomerAuthMePushSubscriptions>>,
      TError,
      { data: PushUnsubscribeRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomerAuthMePushSubscriptions>>,
  TError,
  { data: PushUnsubscribeRequest },
  TContext
> => {
  return useMutation(getDeleteCustomerAuthMePushSubscriptionsMutationOptions(options), queryClient)
}
export const getPostCustomerAuthMeHiddenAddressesUrl = () => {
  return `/api/v1/customer-auth/me/hidden-addresses`
}

/**
 * @summary Stop offering an address
 */
export const postCustomerAuthMeHiddenAddresses = async (
  customerAddressRequest: CustomerAddressRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<HiddenAddressArray> => {
  return customFetch<HiddenAddressArray>(getPostCustomerAuthMeHiddenAddressesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerAddressRequest),
  })
}

export const getPostCustomerAuthMeHiddenAddressesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomerAuthMeHiddenAddresses>>,
    TError,
    { data: CustomerAddressRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomerAuthMeHiddenAddresses>>,
  TError,
  { data: CustomerAddressRequest },
  TContext
> => {
  const mutationKey = ['postCustomerAuthMeHiddenAddresses']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomerAuthMeHiddenAddresses>>,
    { data: CustomerAddressRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomerAuthMeHiddenAddresses(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomerAuthMeHiddenAddressesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomerAuthMeHiddenAddresses>>
>
export type PostCustomerAuthMeHiddenAddressesMutationBody = CustomerAddressRequest
export type PostCustomerAuthMeHiddenAddressesMutationError = unknown

/**
 * @summary Stop offering an address
 */
export const usePostCustomerAuthMeHiddenAddresses = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomerAuthMeHiddenAddresses>>,
      TError,
      { data: CustomerAddressRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomerAuthMeHiddenAddresses>>,
  TError,
  { data: CustomerAddressRequest },
  TContext
> => {
  return useMutation(getPostCustomerAuthMeHiddenAddressesMutationOptions(options), queryClient)
}
export const getDeleteCustomerAuthMeHiddenAddressesUrl = () => {
  return `/api/v1/customer-auth/me/hidden-addresses`
}

/**
 * @summary Offer a hidden address again
 */
export const deleteCustomerAuthMeHiddenAddresses = async (
  customerAddressRequest: CustomerAddressRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<HiddenAddressArray> => {
  return customFetch<HiddenAddressArray>(getDeleteCustomerAuthMeHiddenAddressesUrl(), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerAddressRequest),
  })
}

export const getDeleteCustomerAuthMeHiddenAddressesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomerAuthMeHiddenAddresses>>,
    TError,
    { data: CustomerAddressRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomerAuthMeHiddenAddresses>>,
  TError,
  { data: CustomerAddressRequest },
  TContext
> => {
  const mutationKey = ['deleteCustomerAuthMeHiddenAddresses']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomerAuthMeHiddenAddresses>>,
    { data: CustomerAddressRequest }
  > = (props) => {
    const { data } = props ?? {}

    return deleteCustomerAuthMeHiddenAddresses(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteCustomerAuthMeHiddenAddressesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomerAuthMeHiddenAddresses>>
>
export type DeleteCustomerAuthMeHiddenAddressesMutationBody = CustomerAddressRequest
export type DeleteCustomerAuthMeHiddenAddressesMutationError = unknown

/**
 * @summary Offer a hidden address again
 */
export const useDeleteCustomerAuthMeHiddenAddresses = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCustomerAuthMeHiddenAddresses>>,
      TError,
      { data: CustomerAddressRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomerAuthMeHiddenAddresses>>,
  TError,
  { data: CustomerAddressRequest },
  TContext
> => {
  return useMutation(getDeleteCustomerAuthMeHiddenAddressesMutationOptions(options), queryClient)
}
export const getPostCustomerAuthLogoutUrl = () => {
  return `/api/v1/customer-auth/logout`
}

/**
 * @summary Sign out
 */
export const postCustomerAuthLogout = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerLoggedOut> => {
  return customFetch<CustomerLoggedOut>(getPostCustomerAuthLogoutUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostCustomerAuthLogoutMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomerAuthLogout>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomerAuthLogout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postCustomerAuthLogout']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomerAuthLogout>>,
    void
  > = () => {
    return postCustomerAuthLogout(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomerAuthLogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomerAuthLogout>>
>

export type PostCustomerAuthLogoutMutationError = unknown

/**
 * @summary Sign out
 */
export const usePostCustomerAuthLogout = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomerAuthLogout>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomerAuthLogout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostCustomerAuthLogoutMutationOptions(options), queryClient)
}
export const getPostCustomerAuthLoginUrl = () => {
  return `/api/v1/customer-auth/login`
}

/**
 * @summary Sign in
 */
export const postCustomerAuthLogin = async (
  customerLoginRequest: CustomerLoginRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerSession> => {
  return customFetch<CustomerSession>(getPostCustomerAuthLoginUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerLoginRequest),
  })
}

export const getPostCustomerAuthLoginMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomerAuthLogin>>,
    TError,
    { data: CustomerLoginRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomerAuthLogin>>,
  TError,
  { data: CustomerLoginRequest },
  TContext
> => {
  const mutationKey = ['postCustomerAuthLogin']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomerAuthLogin>>,
    { data: CustomerLoginRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomerAuthLogin(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomerAuthLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomerAuthLogin>>
>
export type PostCustomerAuthLoginMutationBody = CustomerLoginRequest
export type PostCustomerAuthLoginMutationError = unknown

/**
 * @summary Sign in
 */
export const usePostCustomerAuthLogin = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomerAuthLogin>>,
      TError,
      { data: CustomerLoginRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomerAuthLogin>>,
  TError,
  { data: CustomerLoginRequest },
  TContext
> => {
  return useMutation(getPostCustomerAuthLoginMutationOptions(options), queryClient)
}
export const getPostCustomerAuthForgotPasswordUrl = () => {
  return `/api/v1/customer-auth/forgot-password`
}

/**
 * @summary Send a password reset link
 */
export const postCustomerAuthForgotPassword = async (
  customerForgotPasswordRequest: CustomerForgotPasswordRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerForgotPassword> => {
  return customFetch<CustomerForgotPassword>(getPostCustomerAuthForgotPasswordUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerForgotPasswordRequest),
  })
}

export const getPostCustomerAuthForgotPasswordMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCustomerAuthForgotPassword>>,
    TError,
    { data: CustomerForgotPasswordRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCustomerAuthForgotPassword>>,
  TError,
  { data: CustomerForgotPasswordRequest },
  TContext
> => {
  const mutationKey = ['postCustomerAuthForgotPassword']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCustomerAuthForgotPassword>>,
    { data: CustomerForgotPasswordRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postCustomerAuthForgotPassword(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostCustomerAuthForgotPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCustomerAuthForgotPassword>>
>
export type PostCustomerAuthForgotPasswordMutationBody = CustomerForgotPasswordRequest
export type PostCustomerAuthForgotPasswordMutationError = unknown

/**
 * @summary Send a password reset link
 */
export const usePostCustomerAuthForgotPassword = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCustomerAuthForgotPassword>>,
      TError,
      { data: CustomerForgotPasswordRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCustomerAuthForgotPassword>>,
  TError,
  { data: CustomerForgotPasswordRequest },
  TContext
> => {
  return useMutation(getPostCustomerAuthForgotPasswordMutationOptions(options), queryClient)
}
export const getDeleteLoyaltyLevelsLevelIdUrl = (levelId: number) => {
  return `/api/v1/loyalty/levels/${levelId}`
}

/**
 * @summary Remove a tier
 */
export const deleteLoyaltyLevelsLevelId = async (
  levelId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteLoyaltyLevelsLevelIdUrl(levelId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteLoyaltyLevelsLevelIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLoyaltyLevelsLevelId>>,
    TError,
    { levelId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLoyaltyLevelsLevelId>>,
  TError,
  { levelId: number },
  TContext
> => {
  const mutationKey = ['deleteLoyaltyLevelsLevelId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLoyaltyLevelsLevelId>>,
    { levelId: number }
  > = (props) => {
    const { levelId } = props ?? {}

    return deleteLoyaltyLevelsLevelId(levelId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteLoyaltyLevelsLevelIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLoyaltyLevelsLevelId>>
>

export type DeleteLoyaltyLevelsLevelIdMutationError = unknown

/**
 * @summary Remove a tier
 */
export const useDeleteLoyaltyLevelsLevelId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteLoyaltyLevelsLevelId>>,
      TError,
      { levelId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteLoyaltyLevelsLevelId>>,
  TError,
  { levelId: number },
  TContext
> => {
  return useMutation(getDeleteLoyaltyLevelsLevelIdMutationOptions(options), queryClient)
}
export const getPatchLoyaltyLevelsLevelIdUrl = (levelId: number) => {
  return `/api/v1/loyalty/levels/${levelId}`
}

/**
 * @summary Change a tier
 */
export const patchLoyaltyLevelsLevelId = async (
  levelId: number,
  patchLoyaltyLevelsLevelIdBody: PatchLoyaltyLevelsLevelIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<LoyaltyLevelRow> => {
  return customFetch<LoyaltyLevelRow>(getPatchLoyaltyLevelsLevelIdUrl(levelId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchLoyaltyLevelsLevelIdBody),
  })
}

export const getPatchLoyaltyLevelsLevelIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchLoyaltyLevelsLevelId>>,
    TError,
    { levelId: number; data: PatchLoyaltyLevelsLevelIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchLoyaltyLevelsLevelId>>,
  TError,
  { levelId: number; data: PatchLoyaltyLevelsLevelIdBody },
  TContext
> => {
  const mutationKey = ['patchLoyaltyLevelsLevelId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchLoyaltyLevelsLevelId>>,
    { levelId: number; data: PatchLoyaltyLevelsLevelIdBody }
  > = (props) => {
    const { levelId, data } = props ?? {}

    return patchLoyaltyLevelsLevelId(levelId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchLoyaltyLevelsLevelIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchLoyaltyLevelsLevelId>>
>
export type PatchLoyaltyLevelsLevelIdMutationBody = PatchLoyaltyLevelsLevelIdBody
export type PatchLoyaltyLevelsLevelIdMutationError = unknown

/**
 * @summary Change a tier
 */
export const usePatchLoyaltyLevelsLevelId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchLoyaltyLevelsLevelId>>,
      TError,
      { levelId: number; data: PatchLoyaltyLevelsLevelIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchLoyaltyLevelsLevelId>>,
  TError,
  { levelId: number; data: PatchLoyaltyLevelsLevelIdBody },
  TContext
> => {
  return useMutation(getPatchLoyaltyLevelsLevelIdMutationOptions(options), queryClient)
}
export const getGetCustomersCustomerIdUrl = (customerId: number) => {
  return `/api/v1/customers/${customerId}`
}

/**
 * @summary One customer, with their order history
 */
export const getCustomersCustomerId = async (
  customerId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerDetail> => {
  return customFetch<CustomerDetail>(getGetCustomersCustomerIdUrl(customerId), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomersCustomerIdQueryKey = (customerId: number) => {
  return [`/api/v1/customers/${customerId}`] as const
}

export const getGetCustomersCustomerIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomersCustomerId>>,
  TError = unknown,
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersCustomerId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomersCustomerIdQueryKey(customerId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomersCustomerId>>> = ({ signal }) =>
    getCustomersCustomerId(customerId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: customerId !== null && customerId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCustomersCustomerId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetCustomersCustomerIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomersCustomerId>>
>
export type GetCustomersCustomerIdQueryError = unknown

export function useGetCustomersCustomerId<
  TData = Awaited<ReturnType<typeof getCustomersCustomerId>>,
  TError = unknown,
>(
  customerId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersCustomerId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getCustomersCustomerId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersCustomerId<
  TData = Awaited<ReturnType<typeof getCustomersCustomerId>>,
  TError = unknown,
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersCustomerId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getCustomersCustomerId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersCustomerId<
  TData = Awaited<ReturnType<typeof getCustomersCustomerId>>,
  TError = unknown,
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersCustomerId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One customer, with their order history
 */

export function useGetCustomersCustomerId<
  TData = Awaited<ReturnType<typeof getCustomersCustomerId>>,
  TError = unknown,
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersCustomerId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomersCustomerIdQueryOptions(customerId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getDeleteCustomersCustomerIdUrl = (customerId: number) => {
  return `/api/v1/customers/${customerId}`
}

/**
 * @summary Delete a customer
 */
export const deleteCustomersCustomerId = async (
  customerId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerDeleted> => {
  return customFetch<CustomerDeleted>(getDeleteCustomersCustomerIdUrl(customerId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteCustomersCustomerIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomersCustomerId>>,
    TError,
    { customerId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomersCustomerId>>,
  TError,
  { customerId: number },
  TContext
> => {
  const mutationKey = ['deleteCustomersCustomerId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomersCustomerId>>,
    { customerId: number }
  > = (props) => {
    const { customerId } = props ?? {}

    return deleteCustomersCustomerId(customerId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteCustomersCustomerIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomersCustomerId>>
>

export type DeleteCustomersCustomerIdMutationError = unknown

/**
 * @summary Delete a customer
 */
export const useDeleteCustomersCustomerId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCustomersCustomerId>>,
      TError,
      { customerId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomersCustomerId>>,
  TError,
  { customerId: number },
  TContext
> => {
  return useMutation(getDeleteCustomersCustomerIdMutationOptions(options), queryClient)
}
export const getPatchCustomersCustomerIdUrl = (customerId: number) => {
  return `/api/v1/customers/${customerId}`
}

/**
 * @summary Change a customer
 */
export const patchCustomersCustomerId = async (
  customerId: number,
  patchCustomersCustomerIdBody: PatchCustomersCustomerIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerBrief> => {
  return customFetch<CustomerBrief>(getPatchCustomersCustomerIdUrl(customerId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchCustomersCustomerIdBody),
  })
}

export const getPatchCustomersCustomerIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchCustomersCustomerId>>,
    TError,
    { customerId: number; data: PatchCustomersCustomerIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchCustomersCustomerId>>,
  TError,
  { customerId: number; data: PatchCustomersCustomerIdBody },
  TContext
> => {
  const mutationKey = ['patchCustomersCustomerId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchCustomersCustomerId>>,
    { customerId: number; data: PatchCustomersCustomerIdBody }
  > = (props) => {
    const { customerId, data } = props ?? {}

    return patchCustomersCustomerId(customerId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchCustomersCustomerIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchCustomersCustomerId>>
>
export type PatchCustomersCustomerIdMutationBody = PatchCustomersCustomerIdBody
export type PatchCustomersCustomerIdMutationError = unknown

/**
 * @summary Change a customer
 */
export const usePatchCustomersCustomerId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchCustomersCustomerId>>,
      TError,
      { customerId: number; data: PatchCustomersCustomerIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchCustomersCustomerId>>,
  TError,
  { customerId: number; data: PatchCustomersCustomerIdBody },
  TContext
> => {
  return useMutation(getPatchCustomersCustomerIdMutationOptions(options), queryClient)
}
export const getGetCustomerAuthMeUrl = () => {
  return `/api/v1/customer-auth/me`
}

/**
 * @summary The signed-in customer
 */
export const getCustomerAuthMe = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerMe> => {
  return customFetch<CustomerMe>(getGetCustomerAuthMeUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomerAuthMeQueryKey = () => {
  return [`/api/v1/customer-auth/me`] as const
}

export const getGetCustomerAuthMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerAuthMe>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMe>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomerAuthMeQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerAuthMe>>> = ({ signal }) =>
    getCustomerAuthMe({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerAuthMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerAuthMeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerAuthMe>>
>
export type GetCustomerAuthMeQueryError = unknown

export function useGetCustomerAuthMe<
  TData = Awaited<ReturnType<typeof getCustomerAuthMe>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMe>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMe>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMe<
  TData = Awaited<ReturnType<typeof getCustomerAuthMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMe>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMe>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMe<
  TData = Awaited<ReturnType<typeof getCustomerAuthMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMe>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The signed-in customer
 */

export function useGetCustomerAuthMe<
  TData = Awaited<ReturnType<typeof getCustomerAuthMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMe>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomerAuthMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPatchCustomerAuthMeUrl = () => {
  return `/api/v1/customer-auth/me`
}

/**
 * @summary Change the signed-in customer's profile
 */
export const patchCustomerAuthMe = async (
  patchCustomerAuthMeBody: PatchCustomerAuthMeBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerProfileUpdated> => {
  return customFetch<CustomerProfileUpdated>(getPatchCustomerAuthMeUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchCustomerAuthMeBody),
  })
}

export const getPatchCustomerAuthMeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchCustomerAuthMe>>,
    TError,
    { data: PatchCustomerAuthMeBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchCustomerAuthMe>>,
  TError,
  { data: PatchCustomerAuthMeBody },
  TContext
> => {
  const mutationKey = ['patchCustomerAuthMe']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchCustomerAuthMe>>,
    { data: PatchCustomerAuthMeBody }
  > = (props) => {
    const { data } = props ?? {}

    return patchCustomerAuthMe(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchCustomerAuthMeMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchCustomerAuthMe>>
>
export type PatchCustomerAuthMeMutationBody = PatchCustomerAuthMeBody
export type PatchCustomerAuthMeMutationError = unknown

/**
 * @summary Change the signed-in customer's profile
 */
export const usePatchCustomerAuthMe = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchCustomerAuthMe>>,
      TError,
      { data: PatchCustomerAuthMeBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchCustomerAuthMe>>,
  TError,
  { data: PatchCustomerAuthMeBody },
  TContext
> => {
  return useMutation(getPatchCustomerAuthMeMutationOptions(options), queryClient)
}
export const getPatchCustomerAuthMePasswordUrl = () => {
  return `/api/v1/customer-auth/me/password`
}

/**
 * @summary Change the signed-in customer's password
 */
export const patchCustomerAuthMePassword = async (
  customerPasswordChangeRequest: CustomerPasswordChangeRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerPasswordChanged> => {
  return customFetch<CustomerPasswordChanged>(getPatchCustomerAuthMePasswordUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerPasswordChangeRequest),
  })
}

export const getPatchCustomerAuthMePasswordMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchCustomerAuthMePassword>>,
    TError,
    { data: CustomerPasswordChangeRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchCustomerAuthMePassword>>,
  TError,
  { data: CustomerPasswordChangeRequest },
  TContext
> => {
  const mutationKey = ['patchCustomerAuthMePassword']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchCustomerAuthMePassword>>,
    { data: CustomerPasswordChangeRequest }
  > = (props) => {
    const { data } = props ?? {}

    return patchCustomerAuthMePassword(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchCustomerAuthMePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchCustomerAuthMePassword>>
>
export type PatchCustomerAuthMePasswordMutationBody = CustomerPasswordChangeRequest
export type PatchCustomerAuthMePasswordMutationError = unknown

/**
 * @summary Change the signed-in customer's password
 */
export const usePatchCustomerAuthMePassword = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchCustomerAuthMePassword>>,
      TError,
      { data: CustomerPasswordChangeRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchCustomerAuthMePassword>>,
  TError,
  { data: CustomerPasswordChangeRequest },
  TContext
> => {
  return useMutation(getPatchCustomerAuthMePasswordMutationOptions(options), queryClient)
}
export const getPatchCustomerAuthMeAddressLabelUrl = () => {
  return `/api/v1/customer-auth/me/address-label`
}

/**
 * @summary Name an address, or clear its name
 */
export const patchCustomerAuthMeAddressLabel = async (
  customerAddressLabelRequest: CustomerAddressLabelRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<AddressLabels> => {
  return customFetch<AddressLabels>(getPatchCustomerAuthMeAddressLabelUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(customerAddressLabelRequest),
  })
}

export const getPatchCustomerAuthMeAddressLabelMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchCustomerAuthMeAddressLabel>>,
    TError,
    { data: CustomerAddressLabelRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchCustomerAuthMeAddressLabel>>,
  TError,
  { data: CustomerAddressLabelRequest },
  TContext
> => {
  const mutationKey = ['patchCustomerAuthMeAddressLabel']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchCustomerAuthMeAddressLabel>>,
    { data: CustomerAddressLabelRequest }
  > = (props) => {
    const { data } = props ?? {}

    return patchCustomerAuthMeAddressLabel(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchCustomerAuthMeAddressLabelMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchCustomerAuthMeAddressLabel>>
>
export type PatchCustomerAuthMeAddressLabelMutationBody = CustomerAddressLabelRequest
export type PatchCustomerAuthMeAddressLabelMutationError = unknown

/**
 * @summary Name an address, or clear its name
 */
export const usePatchCustomerAuthMeAddressLabel = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchCustomerAuthMeAddressLabel>>,
      TError,
      { data: CustomerAddressLabelRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchCustomerAuthMeAddressLabel>>,
  TError,
  { data: CustomerAddressLabelRequest },
  TContext
> => {
  return useMutation(getPatchCustomerAuthMeAddressLabelMutationOptions(options), queryClient)
}
export const getGetReferralsUrl = (params?: GetReferralsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/referrals?${stringifiedParams}`
    : `/api/v1/referrals`
}

/**
 * @summary Every referral, for the report
 */
export const getReferrals = async (
  params?: GetReferralsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReferralPage> => {
  return customFetch<ReferralPage>(getGetReferralsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetReferralsQueryKey = (params?: GetReferralsParams) => {
  return [`/api/v1/referrals`, ...(params ? [params] : [])] as const
}

export const getGetReferralsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReferrals>>,
  TError = unknown,
>(
  params?: GetReferralsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferrals>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetReferralsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferrals>>> = ({ signal }) =>
    getReferrals(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReferrals>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReferralsQueryResult = NonNullable<Awaited<ReturnType<typeof getReferrals>>>
export type GetReferralsQueryError = unknown

export function useGetReferrals<TData = Awaited<ReturnType<typeof getReferrals>>, TError = unknown>(
  params: undefined | GetReferralsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferrals>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferrals>>,
          TError,
          Awaited<ReturnType<typeof getReferrals>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferrals<TData = Awaited<ReturnType<typeof getReferrals>>, TError = unknown>(
  params?: GetReferralsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferrals>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferrals>>,
          TError,
          Awaited<ReturnType<typeof getReferrals>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferrals<TData = Awaited<ReturnType<typeof getReferrals>>, TError = unknown>(
  params?: GetReferralsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferrals>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every referral, for the report
 */

export function useGetReferrals<TData = Awaited<ReturnType<typeof getReferrals>>, TError = unknown>(
  params?: GetReferralsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferrals>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReferralsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetPushPublicKeyUrl = () => {
  return `/api/v1/push/public-key`
}

/**
 * @summary The VAPID public key, or empty when push is not configured
 */
export const getPushPublicKey = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PushPublicKey> => {
  return customFetch<PushPublicKey>(getGetPushPublicKeyUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetPushPublicKeyQueryKey = () => {
  return [`/api/v1/push/public-key`] as const
}

export const getGetPushPublicKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof getPushPublicKey>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPushPublicKey>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPushPublicKeyQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPushPublicKey>>> = ({ signal }) =>
    getPushPublicKey({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPushPublicKey>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPushPublicKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getPushPublicKey>>>
export type GetPushPublicKeyQueryError = unknown

export function useGetPushPublicKey<
  TData = Awaited<ReturnType<typeof getPushPublicKey>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPushPublicKey>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPushPublicKey>>,
          TError,
          Awaited<ReturnType<typeof getPushPublicKey>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPushPublicKey<
  TData = Awaited<ReturnType<typeof getPushPublicKey>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPushPublicKey>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPushPublicKey>>,
          TError,
          Awaited<ReturnType<typeof getPushPublicKey>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPushPublicKey<
  TData = Awaited<ReturnType<typeof getPushPublicKey>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPushPublicKey>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The VAPID public key, or empty when push is not configured
 */

export function useGetPushPublicKey<
  TData = Awaited<ReturnType<typeof getPushPublicKey>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPushPublicKey>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPushPublicKeyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetLoyaltyPublicInfoUrl = () => {
  return `/api/v1/loyalty/public-info`
}

/**
 * @summary The parts of the loyalty programme safe to publish
 */
export const getLoyaltyPublicInfo = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<LoyaltyPublicInfo> => {
  return customFetch<LoyaltyPublicInfo>(getGetLoyaltyPublicInfoUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetLoyaltyPublicInfoQueryKey = () => {
  return [`/api/v1/loyalty/public-info`] as const
}

export const getGetLoyaltyPublicInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoyaltyPublicInfo>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyPublicInfo>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetLoyaltyPublicInfoQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoyaltyPublicInfo>>> = ({ signal }) =>
    getLoyaltyPublicInfo({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLoyaltyPublicInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoyaltyPublicInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoyaltyPublicInfo>>
>
export type GetLoyaltyPublicInfoQueryError = unknown

export function useGetLoyaltyPublicInfo<
  TData = Awaited<ReturnType<typeof getLoyaltyPublicInfo>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyPublicInfo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoyaltyPublicInfo>>,
          TError,
          Awaited<ReturnType<typeof getLoyaltyPublicInfo>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyPublicInfo<
  TData = Awaited<ReturnType<typeof getLoyaltyPublicInfo>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyPublicInfo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoyaltyPublicInfo>>,
          TError,
          Awaited<ReturnType<typeof getLoyaltyPublicInfo>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyPublicInfo<
  TData = Awaited<ReturnType<typeof getLoyaltyPublicInfo>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyPublicInfo>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The parts of the loyalty programme safe to publish
 */

export function useGetLoyaltyPublicInfo<
  TData = Awaited<ReturnType<typeof getLoyaltyPublicInfo>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyPublicInfo>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLoyaltyPublicInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetLoyaltyCampaignsUrl = () => {
  return `/api/v1/loyalty/campaigns`
}

/**
 * @summary The campaigns already sent
 */
export const getLoyaltyCampaigns = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<LoyaltyCampaign[]> => {
  return customFetch<LoyaltyCampaign[]>(getGetLoyaltyCampaignsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetLoyaltyCampaignsQueryKey = () => {
  return [`/api/v1/loyalty/campaigns`] as const
}

export const getGetLoyaltyCampaignsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoyaltyCampaigns>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyCampaigns>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetLoyaltyCampaignsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoyaltyCampaigns>>> = ({ signal }) =>
    getLoyaltyCampaigns({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLoyaltyCampaigns>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoyaltyCampaignsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoyaltyCampaigns>>
>
export type GetLoyaltyCampaignsQueryError = unknown

export function useGetLoyaltyCampaigns<
  TData = Awaited<ReturnType<typeof getLoyaltyCampaigns>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyCampaigns>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoyaltyCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getLoyaltyCampaigns>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyCampaigns<
  TData = Awaited<ReturnType<typeof getLoyaltyCampaigns>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyCampaigns>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoyaltyCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getLoyaltyCampaigns>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoyaltyCampaigns<
  TData = Awaited<ReturnType<typeof getLoyaltyCampaigns>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyCampaigns>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The campaigns already sent
 */

export function useGetLoyaltyCampaigns<
  TData = Awaited<ReturnType<typeof getLoyaltyCampaigns>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoyaltyCampaigns>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLoyaltyCampaignsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCustomersLoyaltyCheckUrl = (params?: GetCustomersLoyaltyCheckParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/customers/loyalty-check?${stringifiedParams}`
    : `/api/v1/customers/loyalty-check`
}

/**
 * @summary What the loyalty programme knows about an e-mail address
 */
export const getCustomersLoyaltyCheck = async (
  params?: GetCustomersLoyaltyCheckParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<LoyaltyCheckResponse> => {
  return customFetch<LoyaltyCheckResponse>(getGetCustomersLoyaltyCheckUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomersLoyaltyCheckQueryKey = (params?: GetCustomersLoyaltyCheckParams) => {
  return [`/api/v1/customers/loyalty-check`, ...(params ? [params] : [])] as const
}

export const getGetCustomersLoyaltyCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>,
  TError = unknown,
>(
  params?: GetCustomersLoyaltyCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomersLoyaltyCheckQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>> = ({
    signal,
  }) => getCustomersLoyaltyCheck(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomersLoyaltyCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>
>
export type GetCustomersLoyaltyCheckQueryError = unknown

export function useGetCustomersLoyaltyCheck<
  TData = Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>,
  TError = unknown,
>(
  params: undefined | GetCustomersLoyaltyCheckParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>,
          TError,
          Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersLoyaltyCheck<
  TData = Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>,
  TError = unknown,
>(
  params?: GetCustomersLoyaltyCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>,
          TError,
          Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersLoyaltyCheck<
  TData = Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>,
  TError = unknown,
>(
  params?: GetCustomersLoyaltyCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What the loyalty programme knows about an e-mail address
 */

export function useGetCustomersLoyaltyCheck<
  TData = Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>,
  TError = unknown,
>(
  params?: GetCustomersLoyaltyCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersLoyaltyCheck>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomersLoyaltyCheckQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCustomersLookupUrl = (params?: GetCustomersLookupParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/customers/lookup?${stringifiedParams}`
    : `/api/v1/customers/lookup`
}

/**
 * @summary Find a customer by telephone number or e-mail
 */
export const getCustomersLookup = async (
  params?: GetCustomersLookupParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerLookup> => {
  return customFetch<CustomerLookup>(getGetCustomersLookupUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomersLookupQueryKey = (params?: GetCustomersLookupParams) => {
  return [`/api/v1/customers/lookup`, ...(params ? [params] : [])] as const
}

export const getGetCustomersLookupQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomersLookup>>,
  TError = unknown,
>(
  params?: GetCustomersLookupParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersLookup>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomersLookupQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomersLookup>>> = ({ signal }) =>
    getCustomersLookup(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomersLookup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomersLookupQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomersLookup>>
>
export type GetCustomersLookupQueryError = unknown

export function useGetCustomersLookup<
  TData = Awaited<ReturnType<typeof getCustomersLookup>>,
  TError = unknown,
>(
  params: undefined | GetCustomersLookupParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersLookup>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersLookup>>,
          TError,
          Awaited<ReturnType<typeof getCustomersLookup>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersLookup<
  TData = Awaited<ReturnType<typeof getCustomersLookup>>,
  TError = unknown,
>(
  params?: GetCustomersLookupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersLookup>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersLookup>>,
          TError,
          Awaited<ReturnType<typeof getCustomersLookup>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersLookup<
  TData = Awaited<ReturnType<typeof getCustomersLookup>>,
  TError = unknown,
>(
  params?: GetCustomersLookupParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersLookup>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find a customer by telephone number or e-mail
 */

export function useGetCustomersLookup<
  TData = Awaited<ReturnType<typeof getCustomersLookup>>,
  TError = unknown,
>(
  params?: GetCustomersLookupParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersLookup>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomersLookupQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCustomersBulkAnonymizeJobIdUrl = (jobId: string) => {
  return `/api/v1/customers/bulk-anonymize/${jobId}`
}

/**
 * @summary How far an anonymisation job has got
 */
export const getCustomersBulkAnonymizeJobId = async (
  jobId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerAnonymizeJob> => {
  return customFetch<CustomerAnonymizeJob>(getGetCustomersBulkAnonymizeJobIdUrl(jobId), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomersBulkAnonymizeJobIdQueryKey = (jobId: string) => {
  return [`/api/v1/customers/bulk-anonymize/${jobId}`] as const
}

export const getGetCustomersBulkAnonymizeJobIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>,
  TError = unknown,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomersBulkAnonymizeJobIdQueryKey(jobId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>> = ({
    signal,
  }) => getCustomersBulkAnonymizeJobId(jobId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: jobId !== null && jobId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomersBulkAnonymizeJobIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>
>
export type GetCustomersBulkAnonymizeJobIdQueryError = unknown

export function useGetCustomersBulkAnonymizeJobId<
  TData = Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>,
  TError = unknown,
>(
  jobId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>,
          TError,
          Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersBulkAnonymizeJobId<
  TData = Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>,
  TError = unknown,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>,
          TError,
          Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersBulkAnonymizeJobId<
  TData = Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>,
  TError = unknown,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary How far an anonymisation job has got
 */

export function useGetCustomersBulkAnonymizeJobId<
  TData = Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>,
  TError = unknown,
>(
  jobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomersBulkAnonymizeJobId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomersBulkAnonymizeJobIdQueryOptions(jobId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCustomerReferralUrl = () => {
  return `/api/v1/customer/referral`
}

/**
 * @summary This customer's own referral code and link
 */
export const getCustomerReferral = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ReferralInvite> => {
  return customFetch<ReferralInvite>(getGetCustomerReferralUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomerReferralQueryKey = () => {
  return [`/api/v1/customer/referral`] as const
}

export const getGetCustomerReferralQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerReferral>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerReferral>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomerReferralQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerReferral>>> = ({ signal }) =>
    getCustomerReferral({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerReferral>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerReferralQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerReferral>>
>
export type GetCustomerReferralQueryError = unknown

export function useGetCustomerReferral<
  TData = Awaited<ReturnType<typeof getCustomerReferral>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerReferral>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerReferral>>,
          TError,
          Awaited<ReturnType<typeof getCustomerReferral>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerReferral<
  TData = Awaited<ReturnType<typeof getCustomerReferral>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerReferral>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerReferral>>,
          TError,
          Awaited<ReturnType<typeof getCustomerReferral>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerReferral<
  TData = Awaited<ReturnType<typeof getCustomerReferral>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerReferral>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary This customer's own referral code and link
 */

export function useGetCustomerReferral<
  TData = Awaited<ReturnType<typeof getCustomerReferral>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerReferral>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomerReferralQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCustomerAuthPersonalizedSuggestionUrl = () => {
  return `/api/v1/customer-auth/personalized-suggestion`
}

/**
 * @summary What this customer might want to order
 */
export const getCustomerAuthPersonalizedSuggestion = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PersonalisedSuggestion> => {
  return customFetch<PersonalisedSuggestion>(getGetCustomerAuthPersonalizedSuggestionUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomerAuthPersonalizedSuggestionQueryKey = () => {
  return [`/api/v1/customer-auth/personalized-suggestion`] as const
}

export const getGetCustomerAuthPersonalizedSuggestionQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>,
      TError,
      TData
    >
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomerAuthPersonalizedSuggestionQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>
  > = ({ signal }) => getCustomerAuthPersonalizedSuggestion({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerAuthPersonalizedSuggestionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>
>
export type GetCustomerAuthPersonalizedSuggestionQueryError = unknown

export function useGetCustomerAuthPersonalizedSuggestion<
  TData = Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthPersonalizedSuggestion<
  TData = Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthPersonalizedSuggestion<
  TData = Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What this customer might want to order
 */

export function useGetCustomerAuthPersonalizedSuggestion<
  TData = Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAuthPersonalizedSuggestion>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomerAuthPersonalizedSuggestionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCustomerAuthMyOrdersUrl = (params?: GetCustomerAuthMyOrdersParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/customer-auth/my-orders?${stringifiedParams}`
    : `/api/v1/customer-auth/my-orders`
}

/**
 * @summary This customer's orders, newest first
 */
export const getCustomerAuthMyOrders = async (
  params?: GetCustomerAuthMyOrdersParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerOrders> => {
  return customFetch<CustomerOrders>(getGetCustomerAuthMyOrdersUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomerAuthMyOrdersQueryKey = (params?: GetCustomerAuthMyOrdersParams) => {
  return [`/api/v1/customer-auth/my-orders`, ...(params ? [params] : [])] as const
}

export const getGetCustomerAuthMyOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerAuthMyOrders>>,
  TError = unknown,
>(
  params?: GetCustomerAuthMyOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMyOrders>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomerAuthMyOrdersQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerAuthMyOrders>>> = ({
    signal,
  }) => getCustomerAuthMyOrders(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerAuthMyOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerAuthMyOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerAuthMyOrders>>
>
export type GetCustomerAuthMyOrdersQueryError = unknown

export function useGetCustomerAuthMyOrders<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyOrders>>,
  TError = unknown,
>(
  params: undefined | GetCustomerAuthMyOrdersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMyOrders>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMyOrders>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMyOrders>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMyOrders<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyOrders>>,
  TError = unknown,
>(
  params?: GetCustomerAuthMyOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMyOrders>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMyOrders>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMyOrders>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMyOrders<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyOrders>>,
  TError = unknown,
>(
  params?: GetCustomerAuthMyOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMyOrders>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary This customer's orders, newest first
 */

export function useGetCustomerAuthMyOrders<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyOrders>>,
  TError = unknown,
>(
  params?: GetCustomerAuthMyOrdersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMyOrders>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomerAuthMyOrdersQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCustomerAuthMyOrdersOrderIdUrl = (orderId: number) => {
  return `/api/v1/customer-auth/my-orders/${orderId}`
}

/**
 * @summary One of this customer's orders, with its items
 */
export const getCustomerAuthMyOrdersOrderId = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetCustomerAuthMyOrdersOrderId200> => {
  return customFetch<GetCustomerAuthMyOrdersOrderId200>(
    getGetCustomerAuthMyOrdersOrderIdUrl(orderId),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getGetCustomerAuthMyOrdersOrderIdQueryKey = (orderId: number) => {
  return [`/api/v1/customer-auth/my-orders/${orderId}`] as const
}

export const getGetCustomerAuthMyOrdersOrderIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomerAuthMyOrdersOrderIdQueryKey(orderId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>> = ({
    signal,
  }) => getCustomerAuthMyOrdersOrderId(orderId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: orderId !== null && orderId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerAuthMyOrdersOrderIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>
>
export type GetCustomerAuthMyOrdersOrderIdQueryError = unknown

export function useGetCustomerAuthMyOrdersOrderId<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>,
  TError = unknown,
>(
  orderId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMyOrdersOrderId<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMyOrdersOrderId<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One of this customer's orders, with its items
 */

export function useGetCustomerAuthMyOrdersOrderId<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomerAuthMyOrdersOrderIdQueryOptions(orderId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCustomerAuthMyOrdersOrderIdTrackingUrl = (orderId: number) => {
  return `/api/v1/customer-auth/my-orders/${orderId}/tracking`
}

/**
 * @summary Where one of this customer's orders has got to
 */
export const getCustomerAuthMyOrdersOrderIdTracking = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<OrderTracking> => {
  return customFetch<OrderTracking>(getGetCustomerAuthMyOrdersOrderIdTrackingUrl(orderId), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomerAuthMyOrdersOrderIdTrackingQueryKey = (orderId: number) => {
  return [`/api/v1/customer-auth/my-orders/${orderId}/tracking`] as const
}

export const getGetCustomerAuthMyOrdersOrderIdTrackingQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerAuthMyOrdersOrderIdTrackingQueryKey(orderId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>
  > = ({ signal }) => getCustomerAuthMyOrdersOrderIdTracking(orderId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: orderId !== null && orderId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerAuthMyOrdersOrderIdTrackingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>
>
export type GetCustomerAuthMyOrdersOrderIdTrackingQueryError = unknown

export function useGetCustomerAuthMyOrdersOrderIdTracking<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>,
  TError = unknown,
>(
  orderId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMyOrdersOrderIdTracking<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMyOrdersOrderIdTracking<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Where one of this customer's orders has got to
 */

export function useGetCustomerAuthMyOrdersOrderIdTracking<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAuthMyOrdersOrderIdTracking>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomerAuthMyOrdersOrderIdTrackingQueryOptions(orderId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCustomerAuthMyCouponsUrl = () => {
  return `/api/v1/customer-auth/my-coupons`
}

/**
 * @summary The coupons this customer holds
 */
export const getCustomerAuthMyCoupons = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerCoupon[]> => {
  return customFetch<CustomerCoupon[]>(getGetCustomerAuthMyCouponsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomerAuthMyCouponsQueryKey = () => {
  return [`/api/v1/customer-auth/my-coupons`] as const
}

export const getGetCustomerAuthMyCouponsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomerAuthMyCouponsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>> = ({
    signal,
  }) => getCustomerAuthMyCoupons({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerAuthMyCouponsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>
>
export type GetCustomerAuthMyCouponsQueryError = unknown

export function useGetCustomerAuthMyCoupons<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMyCoupons<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMyCoupons<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The coupons this customer holds
 */

export function useGetCustomerAuthMyCoupons<
  TData = Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMyCoupons>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomerAuthMyCouponsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCustomerAuthMeReferralsUrl = (params?: GetCustomerAuthMeReferralsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/customer-auth/me/referrals?${stringifiedParams}`
    : `/api/v1/customer-auth/me/referrals`
}

/**
 * @summary Who this customer has referred, and what they earned
 */
export const getCustomerAuthMeReferrals = async (
  params?: GetCustomerAuthMeReferralsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<CustomerReferrals> => {
  return customFetch<CustomerReferrals>(getGetCustomerAuthMeReferralsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomerAuthMeReferralsQueryKey = (
  params?: GetCustomerAuthMeReferralsParams,
) => {
  return [`/api/v1/customer-auth/me/referrals`, ...(params ? [params] : [])] as const
}

export const getGetCustomerAuthMeReferralsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>,
  TError = unknown,
>(
  params?: GetCustomerAuthMeReferralsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomerAuthMeReferralsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>> = ({
    signal,
  }) => getCustomerAuthMeReferrals(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerAuthMeReferralsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>
>
export type GetCustomerAuthMeReferralsQueryError = unknown

export function useGetCustomerAuthMeReferrals<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>,
  TError = unknown,
>(
  params: undefined | GetCustomerAuthMeReferralsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMeReferrals<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>,
  TError = unknown,
>(
  params?: GetCustomerAuthMeReferralsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMeReferrals<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>,
  TError = unknown,
>(
  params?: GetCustomerAuthMeReferralsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Who this customer has referred, and what they earned
 */

export function useGetCustomerAuthMeReferrals<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>,
  TError = unknown,
>(
  params?: GetCustomerAuthMeReferralsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeReferrals>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomerAuthMeReferralsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCustomerAuthMeMostOrderedUrl = (params?: GetCustomerAuthMeMostOrderedParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/customer-auth/me/most-ordered?${stringifiedParams}`
    : `/api/v1/customer-auth/me/most-ordered`
}

/**
 * @summary The products this customer orders most
 */
export const getCustomerAuthMeMostOrdered = async (
  params?: GetCustomerAuthMeMostOrderedParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<MostOrderedProducts> => {
  return customFetch<MostOrderedProducts>(getGetCustomerAuthMeMostOrderedUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomerAuthMeMostOrderedQueryKey = (
  params?: GetCustomerAuthMeMostOrderedParams,
) => {
  return [`/api/v1/customer-auth/me/most-ordered`, ...(params ? [params] : [])] as const
}

export const getGetCustomerAuthMeMostOrderedQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>,
  TError = unknown,
>(
  params?: GetCustomerAuthMeMostOrderedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomerAuthMeMostOrderedQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>> = ({
    signal,
  }) => getCustomerAuthMeMostOrdered(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerAuthMeMostOrderedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>
>
export type GetCustomerAuthMeMostOrderedQueryError = unknown

export function useGetCustomerAuthMeMostOrdered<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>,
  TError = unknown,
>(
  params: undefined | GetCustomerAuthMeMostOrderedParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMeMostOrdered<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>,
  TError = unknown,
>(
  params?: GetCustomerAuthMeMostOrderedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMeMostOrdered<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>,
  TError = unknown,
>(
  params?: GetCustomerAuthMeMostOrderedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The products this customer orders most
 */

export function useGetCustomerAuthMeMostOrdered<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>,
  TError = unknown,
>(
  params?: GetCustomerAuthMeMostOrderedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeMostOrdered>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomerAuthMeMostOrderedQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetCustomerAuthMeDataExportUrl = () => {
  return `/api/v1/customer-auth/me/data-export`
}

/**
 * @summary Everything held about this customer, as a file
 */
export const getCustomerAuthMeDataExport = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetCustomerAuthMeDataExport200> => {
  return customFetch<GetCustomerAuthMeDataExport200>(getGetCustomerAuthMeDataExportUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetCustomerAuthMeDataExportQueryKey = () => {
  return [`/api/v1/customer-auth/me/data-export`] as const
}

export const getGetCustomerAuthMeDataExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetCustomerAuthMeDataExportQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>> = ({
    signal,
  }) => getCustomerAuthMeDataExport({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerAuthMeDataExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>
>
export type GetCustomerAuthMeDataExportQueryError = unknown

export function useGetCustomerAuthMeDataExport<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMeDataExport<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerAuthMeDataExport<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Everything held about this customer, as a file
 */

export function useGetCustomerAuthMeDataExport<
  TData = Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCustomerAuthMeDataExport>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCustomerAuthMeDataExportQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAnalyticsTimeToFirstOrderUrl = () => {
  return `/api/v1/analytics/time-to-first-order`
}

/**
 * @summary How long customers take to place a first order
 */
export const getAnalyticsTimeToFirstOrder = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<TimeToFirstOrder> => {
  return customFetch<TimeToFirstOrder>(getGetAnalyticsTimeToFirstOrderUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetAnalyticsTimeToFirstOrderQueryKey = () => {
  return [`/api/v1/analytics/time-to-first-order`] as const
}

export const getGetAnalyticsTimeToFirstOrderQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsTimeToFirstOrderQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>> = ({
    signal,
  }) => getAnalyticsTimeToFirstOrder({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsTimeToFirstOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>
>
export type GetAnalyticsTimeToFirstOrderQueryError = unknown

export function useGetAnalyticsTimeToFirstOrder<
  TData = Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsTimeToFirstOrder<
  TData = Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsTimeToFirstOrder<
  TData = Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary How long customers take to place a first order
 */

export function useGetAnalyticsTimeToFirstOrder<
  TData = Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsTimeToFirstOrder>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnalyticsTimeToFirstOrderQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAnalyticsSlaUrl = (params?: GetAnalyticsSlaParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/analytics/sla?${stringifiedParams}`
    : `/api/v1/analytics/sla`
}

/**
 * @summary Whether orders go out on time
 */
export const getAnalyticsSla = async (
  params?: GetAnalyticsSlaParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<SlaAnalytics> => {
  return customFetch<SlaAnalytics>(getGetAnalyticsSlaUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAnalyticsSlaQueryKey = (params?: GetAnalyticsSlaParams) => {
  return [`/api/v1/analytics/sla`, ...(params ? [params] : [])] as const
}

export const getGetAnalyticsSlaQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsSla>>,
  TError = unknown,
>(
  params?: GetAnalyticsSlaParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsSla>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsSlaQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsSla>>> = ({ signal }) =>
    getAnalyticsSla(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsSla>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsSlaQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalyticsSla>>>
export type GetAnalyticsSlaQueryError = unknown

export function useGetAnalyticsSla<
  TData = Awaited<ReturnType<typeof getAnalyticsSla>>,
  TError = unknown,
>(
  params: undefined | GetAnalyticsSlaParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsSla>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsSla>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsSla>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsSla<
  TData = Awaited<ReturnType<typeof getAnalyticsSla>>,
  TError = unknown,
>(
  params?: GetAnalyticsSlaParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsSla>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsSla>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsSla>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsSla<
  TData = Awaited<ReturnType<typeof getAnalyticsSla>>,
  TError = unknown,
>(
  params?: GetAnalyticsSlaParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsSla>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether orders go out on time
 */

export function useGetAnalyticsSla<
  TData = Awaited<ReturnType<typeof getAnalyticsSla>>,
  TError = unknown,
>(
  params?: GetAnalyticsSlaParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsSla>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnalyticsSlaQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAnalyticsRfmUrl = () => {
  return `/api/v1/analytics/rfm`
}

/**
 * @summary Customers grouped by recency, frequency and spend
 */
export const getAnalyticsRfm = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<RfmAnalytics> => {
  return customFetch<RfmAnalytics>(getGetAnalyticsRfmUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetAnalyticsRfmQueryKey = () => {
  return [`/api/v1/analytics/rfm`] as const
}

export const getGetAnalyticsRfmQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsRfm>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsRfm>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsRfmQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsRfm>>> = ({ signal }) =>
    getAnalyticsRfm({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsRfm>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsRfmQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalyticsRfm>>>
export type GetAnalyticsRfmQueryError = unknown

export function useGetAnalyticsRfm<
  TData = Awaited<ReturnType<typeof getAnalyticsRfm>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsRfm>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsRfm>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsRfm>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsRfm<
  TData = Awaited<ReturnType<typeof getAnalyticsRfm>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsRfm>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsRfm>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsRfm>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsRfm<
  TData = Awaited<ReturnType<typeof getAnalyticsRfm>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsRfm>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Customers grouped by recency, frequency and spend
 */

export function useGetAnalyticsRfm<
  TData = Awaited<ReturnType<typeof getAnalyticsRfm>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsRfm>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnalyticsRfmQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAnalyticsRfmCustomersUrl = (params?: GetAnalyticsRfmCustomersParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/analytics/rfm/customers?${stringifiedParams}`
    : `/api/v1/analytics/rfm/customers`
}

/**
 * @summary The customers in one RFM segment
 */
export const getAnalyticsRfmCustomers = async (
  params?: GetAnalyticsRfmCustomersParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<RfmSegmentCustomers> => {
  return customFetch<RfmSegmentCustomers>(getGetAnalyticsRfmCustomersUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAnalyticsRfmCustomersQueryKey = (params?: GetAnalyticsRfmCustomersParams) => {
  return [`/api/v1/analytics/rfm/customers`, ...(params ? [params] : [])] as const
}

export const getGetAnalyticsRfmCustomersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>,
  TError = unknown,
>(
  params?: GetAnalyticsRfmCustomersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsRfmCustomersQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>> = ({
    signal,
  }) => getAnalyticsRfmCustomers(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsRfmCustomersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>
>
export type GetAnalyticsRfmCustomersQueryError = unknown

export function useGetAnalyticsRfmCustomers<
  TData = Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>,
  TError = unknown,
>(
  params: undefined | GetAnalyticsRfmCustomersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsRfmCustomers<
  TData = Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>,
  TError = unknown,
>(
  params?: GetAnalyticsRfmCustomersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsRfmCustomers<
  TData = Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>,
  TError = unknown,
>(
  params?: GetAnalyticsRfmCustomersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The customers in one RFM segment
 */

export function useGetAnalyticsRfmCustomers<
  TData = Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>,
  TError = unknown,
>(
  params?: GetAnalyticsRfmCustomersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsRfmCustomers>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnalyticsRfmCustomersQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAnalyticsRevenueUrl = (params?: GetAnalyticsRevenueParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/analytics/revenue?${stringifiedParams}`
    : `/api/v1/analytics/revenue`
}

/**
 * @summary Revenue, average order value, channel split and repeat rate
 */
export const getAnalyticsRevenue = async (
  params?: GetAnalyticsRevenueParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<RevenueAnalytics> => {
  return customFetch<RevenueAnalytics>(getGetAnalyticsRevenueUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAnalyticsRevenueQueryKey = (params?: GetAnalyticsRevenueParams) => {
  return [`/api/v1/analytics/revenue`, ...(params ? [params] : [])] as const
}

export const getGetAnalyticsRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsRevenue>>,
  TError = unknown,
>(
  params?: GetAnalyticsRevenueParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsRevenue>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsRevenueQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsRevenue>>> = ({ signal }) =>
    getAnalyticsRevenue(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsRevenue>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsRevenueQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsRevenue>>
>
export type GetAnalyticsRevenueQueryError = unknown

export function useGetAnalyticsRevenue<
  TData = Awaited<ReturnType<typeof getAnalyticsRevenue>>,
  TError = unknown,
>(
  params: undefined | GetAnalyticsRevenueParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsRevenue>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsRevenue>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsRevenue>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsRevenue<
  TData = Awaited<ReturnType<typeof getAnalyticsRevenue>>,
  TError = unknown,
>(
  params?: GetAnalyticsRevenueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsRevenue>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsRevenue>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsRevenue>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsRevenue<
  TData = Awaited<ReturnType<typeof getAnalyticsRevenue>>,
  TError = unknown,
>(
  params?: GetAnalyticsRevenueParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsRevenue>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Revenue, average order value, channel split and repeat rate
 */

export function useGetAnalyticsRevenue<
  TData = Awaited<ReturnType<typeof getAnalyticsRevenue>>,
  TError = unknown,
>(
  params?: GetAnalyticsRevenueParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsRevenue>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnalyticsRevenueQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAnalyticsPizzaIngredientsMarginUrl = (
  params?: GetAnalyticsPizzaIngredientsMarginParams,
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/analytics/pizza-ingredients-margin?${stringifiedParams}`
    : `/api/v1/analytics/pizza-ingredients-margin`
}

/**
 * @summary What a customer-built pizza makes after its ingredients
 */
export const getAnalyticsPizzaIngredientsMargin = async (
  params?: GetAnalyticsPizzaIngredientsMarginParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PizzaIngredientsMarginAnalytics> => {
  return customFetch<PizzaIngredientsMarginAnalytics>(
    getGetAnalyticsPizzaIngredientsMarginUrl(params),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getGetAnalyticsPizzaIngredientsMarginQueryKey = (
  params?: GetAnalyticsPizzaIngredientsMarginParams,
) => {
  return [`/api/v1/analytics/pizza-ingredients-margin`, ...(params ? [params] : [])] as const
}

export const getGetAnalyticsPizzaIngredientsMarginQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>,
  TError = unknown,
>(
  params?: GetAnalyticsPizzaIngredientsMarginParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsPizzaIngredientsMarginQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>> = ({
    signal,
  }) => getAnalyticsPizzaIngredientsMargin(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsPizzaIngredientsMarginQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>
>
export type GetAnalyticsPizzaIngredientsMarginQueryError = unknown

export function useGetAnalyticsPizzaIngredientsMargin<
  TData = Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>,
  TError = unknown,
>(
  params: undefined | GetAnalyticsPizzaIngredientsMarginParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsPizzaIngredientsMargin<
  TData = Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>,
  TError = unknown,
>(
  params?: GetAnalyticsPizzaIngredientsMarginParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsPizzaIngredientsMargin<
  TData = Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>,
  TError = unknown,
>(
  params?: GetAnalyticsPizzaIngredientsMarginParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What a customer-built pizza makes after its ingredients
 */

export function useGetAnalyticsPizzaIngredientsMargin<
  TData = Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>,
  TError = unknown,
>(
  params?: GetAnalyticsPizzaIngredientsMarginParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsPizzaIngredientsMargin>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnalyticsPizzaIngredientsMarginQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAnalyticsMarginsUrl = (params?: GetAnalyticsMarginsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/analytics/margins?${stringifiedParams}`
    : `/api/v1/analytics/margins`
}

/**
 * @summary What each product makes after cost
 */
export const getAnalyticsMargins = async (
  params?: GetAnalyticsMarginsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<MarginAnalytics> => {
  return customFetch<MarginAnalytics>(getGetAnalyticsMarginsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAnalyticsMarginsQueryKey = (params?: GetAnalyticsMarginsParams) => {
  return [`/api/v1/analytics/margins`, ...(params ? [params] : [])] as const
}

export const getGetAnalyticsMarginsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsMargins>>,
  TError = unknown,
>(
  params?: GetAnalyticsMarginsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsMargins>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsMarginsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsMargins>>> = ({ signal }) =>
    getAnalyticsMargins(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsMargins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsMarginsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsMargins>>
>
export type GetAnalyticsMarginsQueryError = unknown

export function useGetAnalyticsMargins<
  TData = Awaited<ReturnType<typeof getAnalyticsMargins>>,
  TError = unknown,
>(
  params: undefined | GetAnalyticsMarginsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsMargins>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsMargins>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsMargins>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsMargins<
  TData = Awaited<ReturnType<typeof getAnalyticsMargins>>,
  TError = unknown,
>(
  params?: GetAnalyticsMarginsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsMargins>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsMargins>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsMargins>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsMargins<
  TData = Awaited<ReturnType<typeof getAnalyticsMargins>>,
  TError = unknown,
>(
  params?: GetAnalyticsMarginsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsMargins>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What each product makes after cost
 */

export function useGetAnalyticsMargins<
  TData = Awaited<ReturnType<typeof getAnalyticsMargins>>,
  TError = unknown,
>(
  params?: GetAnalyticsMarginsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsMargins>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnalyticsMarginsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAnalyticsLoyaltyStatsUrl = (params?: GetAnalyticsLoyaltyStatsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/analytics/loyalty-stats?${stringifiedParams}`
    : `/api/v1/analytics/loyalty-stats`
}

/**
 * @summary Tier distribution, points and referrals
 */
export const getAnalyticsLoyaltyStats = async (
  params?: GetAnalyticsLoyaltyStatsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<LoyaltyAnalytics> => {
  return customFetch<LoyaltyAnalytics>(getGetAnalyticsLoyaltyStatsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAnalyticsLoyaltyStatsQueryKey = (params?: GetAnalyticsLoyaltyStatsParams) => {
  return [`/api/v1/analytics/loyalty-stats`, ...(params ? [params] : [])] as const
}

export const getGetAnalyticsLoyaltyStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>,
  TError = unknown,
>(
  params?: GetAnalyticsLoyaltyStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsLoyaltyStatsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>> = ({
    signal,
  }) => getAnalyticsLoyaltyStats(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsLoyaltyStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>
>
export type GetAnalyticsLoyaltyStatsQueryError = unknown

export function useGetAnalyticsLoyaltyStats<
  TData = Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>,
  TError = unknown,
>(
  params: undefined | GetAnalyticsLoyaltyStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsLoyaltyStats<
  TData = Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>,
  TError = unknown,
>(
  params?: GetAnalyticsLoyaltyStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsLoyaltyStats<
  TData = Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>,
  TError = unknown,
>(
  params?: GetAnalyticsLoyaltyStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Tier distribution, points and referrals
 */

export function useGetAnalyticsLoyaltyStats<
  TData = Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>,
  TError = unknown,
>(
  params?: GetAnalyticsLoyaltyStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsLoyaltyStats>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnalyticsLoyaltyStatsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAnalyticsGameCorrelationUrl = (params?: GetAnalyticsGameCorrelationParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/analytics/game-correlation?${stringifiedParams}`
    : `/api/v1/analytics/game-correlation`
}

/**
 * @summary Whether playing the games leads to ordering
 */
export const getAnalyticsGameCorrelation = async (
  params?: GetAnalyticsGameCorrelationParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GameCorrelationAnalytics> => {
  return customFetch<GameCorrelationAnalytics>(getGetAnalyticsGameCorrelationUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAnalyticsGameCorrelationQueryKey = (
  params?: GetAnalyticsGameCorrelationParams,
) => {
  return [`/api/v1/analytics/game-correlation`, ...(params ? [params] : [])] as const
}

export const getGetAnalyticsGameCorrelationQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>,
  TError = unknown,
>(
  params?: GetAnalyticsGameCorrelationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsGameCorrelationQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>> = ({
    signal,
  }) => getAnalyticsGameCorrelation(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsGameCorrelationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>
>
export type GetAnalyticsGameCorrelationQueryError = unknown

export function useGetAnalyticsGameCorrelation<
  TData = Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>,
  TError = unknown,
>(
  params: undefined | GetAnalyticsGameCorrelationParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsGameCorrelation<
  TData = Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>,
  TError = unknown,
>(
  params?: GetAnalyticsGameCorrelationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsGameCorrelation<
  TData = Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>,
  TError = unknown,
>(
  params?: GetAnalyticsGameCorrelationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether playing the games leads to ordering
 */

export function useGetAnalyticsGameCorrelation<
  TData = Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>,
  TError = unknown,
>(
  params?: GetAnalyticsGameCorrelationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsGameCorrelation>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnalyticsGameCorrelationQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAnalyticsDayHourRevenueUrl = (params?: GetAnalyticsDayHourRevenueParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/analytics/day-hour-revenue?${stringifiedParams}`
    : `/api/v1/analytics/day-hour-revenue`
}

/**
 * @summary Revenue by day of week and hour
 */
export const getAnalyticsDayHourRevenue = async (
  params?: GetAnalyticsDayHourRevenueParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DayHourRevenue> => {
  return customFetch<DayHourRevenue>(getGetAnalyticsDayHourRevenueUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAnalyticsDayHourRevenueQueryKey = (
  params?: GetAnalyticsDayHourRevenueParams,
) => {
  return [`/api/v1/analytics/day-hour-revenue`, ...(params ? [params] : [])] as const
}

export const getGetAnalyticsDayHourRevenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>,
  TError = unknown,
>(
  params?: GetAnalyticsDayHourRevenueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsDayHourRevenueQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>> = ({
    signal,
  }) => getAnalyticsDayHourRevenue(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsDayHourRevenueQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>
>
export type GetAnalyticsDayHourRevenueQueryError = unknown

export function useGetAnalyticsDayHourRevenue<
  TData = Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>,
  TError = unknown,
>(
  params: undefined | GetAnalyticsDayHourRevenueParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsDayHourRevenue<
  TData = Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>,
  TError = unknown,
>(
  params?: GetAnalyticsDayHourRevenueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsDayHourRevenue<
  TData = Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>,
  TError = unknown,
>(
  params?: GetAnalyticsDayHourRevenueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Revenue by day of week and hour
 */

export function useGetAnalyticsDayHourRevenue<
  TData = Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>,
  TError = unknown,
>(
  params?: GetAnalyticsDayHourRevenueParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsDayHourRevenue>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnalyticsDayHourRevenueQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAnalyticsCouponsRoiUrl = (params?: GetAnalyticsCouponsRoiParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/analytics/coupons-roi?${stringifiedParams}`
    : `/api/v1/analytics/coupons-roi`
}

/**
 * @summary What each coupon cost and returned
 */
export const getAnalyticsCouponsRoi = async (
  params?: GetAnalyticsCouponsRoiParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<CouponRoiAnalytics> => {
  return customFetch<CouponRoiAnalytics>(getGetAnalyticsCouponsRoiUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAnalyticsCouponsRoiQueryKey = (params?: GetAnalyticsCouponsRoiParams) => {
  return [`/api/v1/analytics/coupons-roi`, ...(params ? [params] : [])] as const
}

export const getGetAnalyticsCouponsRoiQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>,
  TError = unknown,
>(
  params?: GetAnalyticsCouponsRoiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsCouponsRoiQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>> = ({ signal }) =>
    getAnalyticsCouponsRoi(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsCouponsRoiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>
>
export type GetAnalyticsCouponsRoiQueryError = unknown

export function useGetAnalyticsCouponsRoi<
  TData = Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>,
  TError = unknown,
>(
  params: undefined | GetAnalyticsCouponsRoiParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsCouponsRoi<
  TData = Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>,
  TError = unknown,
>(
  params?: GetAnalyticsCouponsRoiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsCouponsRoi<
  TData = Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>,
  TError = unknown,
>(
  params?: GetAnalyticsCouponsRoiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What each coupon cost and returned
 */

export function useGetAnalyticsCouponsRoi<
  TData = Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>,
  TError = unknown,
>(
  params?: GetAnalyticsCouponsRoiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCouponsRoi>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnalyticsCouponsRoiQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAnalyticsCohortsUrl = (params?: GetAnalyticsCohortsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/analytics/cohorts?${stringifiedParams}`
    : `/api/v1/analytics/cohorts`
}

/**
 * @summary Retention by the month a customer joined
 */
export const getAnalyticsCohorts = async (
  params?: GetAnalyticsCohortsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<CohortAnalytics> => {
  return customFetch<CohortAnalytics>(getGetAnalyticsCohortsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAnalyticsCohortsQueryKey = (params?: GetAnalyticsCohortsParams) => {
  return [`/api/v1/analytics/cohorts`, ...(params ? [params] : [])] as const
}

export const getGetAnalyticsCohortsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsCohorts>>,
  TError = unknown,
>(
  params?: GetAnalyticsCohortsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCohorts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsCohortsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsCohorts>>> = ({ signal }) =>
    getAnalyticsCohorts(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsCohorts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsCohortsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsCohorts>>
>
export type GetAnalyticsCohortsQueryError = unknown

export function useGetAnalyticsCohorts<
  TData = Awaited<ReturnType<typeof getAnalyticsCohorts>>,
  TError = unknown,
>(
  params: undefined | GetAnalyticsCohortsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCohorts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsCohorts>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsCohorts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsCohorts<
  TData = Awaited<ReturnType<typeof getAnalyticsCohorts>>,
  TError = unknown,
>(
  params?: GetAnalyticsCohortsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCohorts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsCohorts>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsCohorts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsCohorts<
  TData = Awaited<ReturnType<typeof getAnalyticsCohorts>>,
  TError = unknown,
>(
  params?: GetAnalyticsCohortsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCohorts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retention by the month a customer joined
 */

export function useGetAnalyticsCohorts<
  TData = Awaited<ReturnType<typeof getAnalyticsCohorts>>,
  TError = unknown,
>(
  params?: GetAnalyticsCohortsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCohorts>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnalyticsCohortsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAnalyticsCampaignsUrl = (params?: GetAnalyticsCampaignsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/analytics/campaigns?${stringifiedParams}`
    : `/api/v1/analytics/campaigns`
}

/**
 * @summary What the campaigns sent so far achieved
 */
export const getAnalyticsCampaigns = async (
  params?: GetAnalyticsCampaignsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<CampaignAnalytics> => {
  return customFetch<CampaignAnalytics>(getGetAnalyticsCampaignsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAnalyticsCampaignsQueryKey = (params?: GetAnalyticsCampaignsParams) => {
  return [`/api/v1/analytics/campaigns`, ...(params ? [params] : [])] as const
}

export const getGetAnalyticsCampaignsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsCampaigns>>,
  TError = unknown,
>(
  params?: GetAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCampaigns>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsCampaignsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsCampaigns>>> = ({ signal }) =>
    getAnalyticsCampaigns(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsCampaigns>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsCampaignsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsCampaigns>>
>
export type GetAnalyticsCampaignsQueryError = unknown

export function useGetAnalyticsCampaigns<
  TData = Awaited<ReturnType<typeof getAnalyticsCampaigns>>,
  TError = unknown,
>(
  params: undefined | GetAnalyticsCampaignsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCampaigns>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsCampaigns>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsCampaigns<
  TData = Awaited<ReturnType<typeof getAnalyticsCampaigns>>,
  TError = unknown,
>(
  params?: GetAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCampaigns>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsCampaigns>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsCampaigns<
  TData = Awaited<ReturnType<typeof getAnalyticsCampaigns>>,
  TError = unknown,
>(
  params?: GetAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCampaigns>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What the campaigns sent so far achieved
 */

export function useGetAnalyticsCampaigns<
  TData = Awaited<ReturnType<typeof getAnalyticsCampaigns>>,
  TError = unknown,
>(
  params?: GetAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsCampaigns>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnalyticsCampaignsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
